@if (kirjanpitajaOnDevaajaObservable | async) {
  <div style="padding-bottom: 20px">
    <h3 style="margin: 0">Urit</h3>
    <div style="padding-top: 1em; padding-left: 1em; padding-right: 1em">
      Käyttäjän tallentamat tiedot: <a [href]="liitetiedotEncodedUriObservable | async" target="_BLANK">{{ liitetiedotUriObservable | async }}</a>
    </div>
  </div>
}

@if (liiteJaLukitustiedotObservable | async; as data) {
  <div style="display: flex; justify-content: space-between">
    <app-icon-button (click)="downloadPdf()" actionId="Lataa liitetiedot koneelle">
      <div class="pdf-btn">
        <div>PDF</div>
        <mat-icon style="font-size: 14px; height: 15px; line-height: 15px">save_alt</mat-icon>
      </div>
    </app-icon-button>
    @if (!data.lukittu) {
      <form>
        <div style="text-align: right">
          Tee liitetiedot päivälle
          <mat-form-field style="max-width: 110px">
            <input style="text-align: center" type="text" [matDatepicker]="loppuuPicker" [min]="minLoppuuDateObservable | async" [max]="maxLoppuuDateObservable | async" [formField]="loppuuLomake.loppuu" placeholder="Päivä" matInput data-lpignore="true" (dateChange)="tallennaLoppuu()" />
            <mat-datepicker-toggle matSuffix [for]="loppuuPicker"></mat-datepicker-toggle>
            <mat-datepicker #loppuuPicker></mat-datepicker>
          </mat-form-field>
          <app-primary-button (click)="tallennaLoppuu()" actionId="Tallenna liitetiedot loppuu päivämäärä (välitilinpäätös)" [actionContext]="[loppuuLomake().value()]" styles="margin-left: 10px;"> Tallenna </app-primary-button>
        </div>
        @if (pvmSaveSuccessObservable | async) {
          <span>
            <span class="save-success-text" [@quickInSlowOut]="'in'" style="color: gray"> Päivämäärä tallennettiin </span>
            <mat-icon class="save-success-icon" [@quickInSlowOut]="'in'" [ngStyle]="{ color: '#4bd76b', 'vertical-align': 'middle' }">done</mat-icon>
          </span>
        }
      </form>
    }
  </div>
  @if (data.lukittu) {
    <div style="padding: 3em; font-weight: bold">Tilinpäätös on rekisteröity. Tietoja ei voi enää muokata.</div>
  }
  <form>
    <div style="margin-left: 10px">
      @if ({ onkoMikro: (onMikroYritysObservable | async) }; as yritys) {
        <h1 style="margin-top: 40px">Liitetiedot</h1>
        <h2 class="otsikko">
          {{ 'PMA1_1_5.title' | translatetilinpaatos: 2021 | async }}
          <!-- Tietoa tilinpäätöksen laatimissäännöksestä (PMA 1:1.5) -->
          <!-- <button mat-icon-button style="vertical-align: top;" (click)="avaaInfoTeksti('Tässä on teksti')">
          <i class="icon ion-ios-information-circle-outline" style="font-size: 28px; color: gray;" aria-hidden="true"></i>
        </button> -->
        </h2>
        <div style="margin: 15px 0">{{ (yritys.onkoMikro ? 'PMA1_1_5.mikroyritys' : 'PMA1_1_5.pienyritys') | translatetilinpaatos: 2021 | async }}</div>
        <h2 class="otsikko">
          {{ 'PMA3_1.title' | translatetilinpaatos: 2021 | async }}
          <!-- <button mat-icon-button style="vertical-align: top;" (click)="avaaInfoTeksti('Tässä on teksti')">
        <i class="icon ion-ios-information-circle-outline" style="font-size: 28px; color: gray;" aria-hidden="true"></i>
      </button> -->
        </h2>
        <div style="margin: 15px 0; font-size: 120%; font-weight: bold">{{ 'PMA3_1.noudatetut-arvostusperiaatteet' | translatetilinpaatos: 2021 | async }}</div>
        <div style="padding: 0 15px">
          <div
            app-kirjanpito-liitetiedot-checkbox
            [formDisabled]="data.lukittu"
            (tallennaArvo)="tallennaMuuttunutArvo($event)"
            [parent]="osiot.PMA3_1_A"
            [field]="kentat.PMA3_1_A_1"
            [order]="1"
            [info]="'Vaihto-omaisuuden käyttöjärjestys on lähtökohtaisesti FIFO (first in first out) -periaatteen mukainen. Jos siitä poiketaan, pitää antaa liitetieto.'"
            [example]="'Esim. Vaihto-omaisuuden käyttöjärjestys on LIFO-periaatteen mukainen.'"
            [unsaved]="data.tallentamattomat"
            [liitetiedot]="data.liitetiedot"
            (checkboxChanged)="checkboxChanged()"
          ></div>
          <div
            app-kirjanpito-liitetiedot-checkbox
            [formDisabled]="data.lukittu"
            (tallennaArvo)="tallennaMuuttunutArvo($event)"
            [parent]="osiot.PMA3_1_A"
            [field]="kentat.PMA3_1_A_2"
            [order]="2"
            [info]="'<b>KPL 5 luku 5 a §</b><br/><br/>
        Aineettomaan omaisuuteen kuuluvien vastikkeellisesti hankittujen toimilupien, patenttien, lisenssien ja tavaramerkkien sekä muiden vastaavien oikeuksien hankintameno on aktivoitava, jos oikeuden arvioidaan tuottavan tuloa useampana tilikautena.<br/><br/>
        Jos kirjanpitovelvollinen on itse luonut 1 momentissa tarkoitetun aineettoman oikeuden, sen hankintameno saadaan aktivoida varovaisuutta noudattaen edellyttäen, että oikeuden arvioidaan tuottavan tuloa useampana tilikautena.<br/><br/>
        Edellä 1 ja 2 momentissa tarkoitettu aktivoitu hankintameno on poistettava suunnitelman mukaan vaikutusaikanaan.'"
            [example]="'Esim. Aineettomiin oikeuksiin aktivoitu franchising sopimusmaksu poistetaan vaikutusaikanaan tasapoistoin 5 vuodessa.'"
            [unsaved]="data.tallentamattomat"
            [liitetiedot]="data.liitetiedot"
            (checkboxChanged)="checkboxChanged()"
          ></div>
          <div
            app-kirjanpito-liitetiedot-checkbox
            [formDisabled]="data.lukittu"
            (tallennaArvo)="tallennaMuuttunutArvo($event)"
            [parent]="osiot.PMA3_1_A"
            [field]="kentat.PMA3_1_A_3"
            [order]="3"
            [info]="'<b>KPL 5 luku</b><br/><br/>
        <b>8 §<br/>
        Tutkimus- ja kehittämismenojen jaksottaminen</b>
        Tutkimusmenot kirjataan tilikauden kuluksi.<br/><br/>
        Kehittämismenot saadaan aktivoida, jos niiden odotetaan tuottavan tuloa useampana tilikautena. Aktivoidut kehittämismenot on poistettava suunnitelman mukaan vaikutusaikanaan. Jollei kirjanpitovelvollinen voi luotettavalla tavalla arvioida vaikutusaikaa, on kehittämismenot poistettava enintään kymmenessä vuodessa. Kehittämismenoja ei saada aktivoida muina pitkävaikutteisina menoina.<br/><br/>
        Jos kehittämismenoja on aktivoitu, ei aktivoinnista vielä kuluksi kirjaamatonta määrää saada jakaa tilikauden tuloksesta, voittovaroista tai muista jakokelpoisista rahastoista kirjanpitovelvollisessa, joka on:<br/>
        <ol>
          <li>osakeyhtiö tai muussa laissa osakeyhtiölain noudattamiseen velvoitettu yhteisö;</li>
          <li>sellainen avoin yhtiö tai kommandiittiyhtiö, jonka kaikki vastuunalaiset yhtiömiehet ovat osakeyhtiöitä; tai</li>
          <li>osuuskunta tai muussa laissa osuuskuntalain noudattamiseen velvoitettu yhteisö.</li>
        </ol><br/><br/>
        <b>9 §<br/>
        Liikearvon hankintamenon jaksottaminen</b><br/><br/>
        Liikearvon hankintameno saadaan aktivoida. Aktivoitu liikearvo on poistettava suunnitelman mukaan vaikutusaikanaan. Jollei kirjanpitovelvollinen voi luotettavalla tavalla arvioida vaikutusaikaa, on liikearvo poistettava enintään kymmenessä vuodessa.<br/><br/>
        <b>11 §<br/>
        Muiden pitkävaikutteisten menojen jaksottaminen</b><br/><br/>
        Jos muita kuin 7-10 §:ssä tarkoitettuja pitkävaikutteisia menoja on aktivoitu, ne on poistettava suunnitelman mukaan vaikutusaikanaan. Jollei kirjanpitovelvollinen voi luotettavalla tavalla arvioida vaikutusaikaa, on meno poistettava enintään kymmenessä vuodessa.'"
            [example]="'Esim. Kehittämismenoja on aktivoitu KPL 5:8 §:n mukaisesti liittyen yhtiön uuden mobiilisovelluksen kehittämiseen. Kehittämismenot on aktivoitu vain niiden hankkeiden osalta, joissa kehittämismenojen taloudellisen vaikutusajan on arvioitu olevan vähintään kolme vuotta. Kehittämismenot poistetaan arvioituna taloudellisena vaikutusaikana tasapoistoin. Uuden mobiilisovelluksen osalta näin on määritelty poistoajaksi 5 vuotta.
<br/><br />
Liikearvona on aktivoitu KPL 5:9 §:n mukaisesti liiketoimintakaupasta vuonna 2019 syntynyt 50 000 euron liikearvo. Liikearvo perustuu hankitun liiketoiminnan tuottoarvoon. Liikearvo poistetaan arvioituna taloudellisena vaikutusaikanaan tasapoistoin 5 vuodessa.
<br /><br />
Muina pitkävaikutteisina menoina on aktivoitu vuonna 2018 tehdyistä tuotantotiloina käytettävän vuokrahuoneiston muutostöistä aiheutuneet perusparannusmenot, jotka poistetaan arvioituna taloudellisena vaikutusaikanaan tasapoistoin 5 vuodessa.'"
            [unsaved]="data.tallentamattomat"
            [liitetiedot]="data.liitetiedot"
            (checkboxChanged)="checkboxChanged()"
          ></div>
          <div
            app-kirjanpito-liitetiedot-checkbox
            [formDisabled]="data.lukittu"
            (tallennaArvo)="tallennaMuuttunutArvo($event)"
            [parent]="osiot.PMA3_1_A"
            [field]="kentat.PMA3_1_A_4"
            [order]="4"
            [info]="'Kirjanpitolautakunnan yleisohje Tulon kirjaaminen tuotoksi valmistusasteen perusteella:

<a href=&quot;https://kirjanpitolautakunta.fi/-/tulon-kirjaaminen-tuotoksi-valmistusasteen-perusteella&quot; target=&quot;_blank&quot;>https://kirjanpitolautakunta.fi/-/tulon-kirjaaminen-tuotoksi-valmistusasteen-perusteella</a>'"
            [unsaved]="data.tallentamattomat"
            [liitetiedot]="data.liitetiedot"
            (checkboxChanged)="checkboxChanged()"
          ></div>
          <div
            app-kirjanpito-liitetiedot-checkbox
            [formDisabled]="data.lukittu"
            (tallennaArvo)="tallennaMuuttunutArvo($event)"
            [parent]="osiot.PMA3_1_A"
            [field]="kentat.PMA3_1_A_5"
            [order]="5"
            [info]="'Rahoitusvälineitä ja sijotuskiinteistöjä voidaan merkitä kirjanpitolain mukaisessa tilinpäätöksessä käypään arvoonsa noudattaen IFRS-standardien mukaista menettelyä.'"
            [unsaved]="data.tallentamattomat"
            [liitetiedot]="data.liitetiedot"
            (checkboxChanged)="checkboxChanged()"
          ></div>
          <div app-kirjanpito-liitetiedot-checkbox [formDisabled]="data.lukittu" (tallennaArvo)="tallennaMuuttunutArvo($event)" [parent]="osiot.PMA3_1_A" [field]="kentat.PMA3_1_A_6" [order]="6" [unsaved]="data.tallentamattomat" [liitetiedot]="data.liitetiedot" (checkboxChanged)="checkboxChanged()"></div>
        </div>
        <div style="margin: 15px 0; font-size: 120%; font-weight: bold">Pysyviin vastaaviin kuuluvien hyödykkeiden arvostamisessa ja jaksottamisessa käytetyt menetelmät ja periaatteet:</div>
        <div style="padding: 0 15px">
          <div
            app-kirjanpito-liitetiedot-checkbox
            [formDisabled]="data.lukittu"
            (tallennaArvo)="tallennaMuuttunutArvo($event)"
            [parent]="osiot.PMA3_1_B"
            [field]="kentat.PMA3_1_B_1"
            [order]="1"
            [info]="'Kun hyödykkeen hankintaan ja valmistukseen liittyviä kiinteitä menoja ryhdytään lukemaan muuttuvien menojen lisäksi hankintamenoon, muutos hankintamenon määrittelyssä pienentää tilikauden kuluja tilinpäätöksessä aktivoitaviin hankintamenoihin sisältyvien kiinteiden menojen osalta. Siirtymisellä hankintamenon uuteen määrittelyyn voi olla olennainen vaikutus tuloslaskelman ja taseen toiminnan tuloksesta ja taloudellisesta asemasta antamaan kuvaan.
<br/><br />
Hyödykkeen hankintamenoon saadaan välittömien menojen lisäksi lukea kohtuullinen osuus hankinnan ja valmistuksen välillisistä menoista siltä osin kuin nämä kohdistuvat tuotantojaksoon. Nämä välilliset menot on voitava selvittää kustannuslaskelman tai -laskelmien avulla.
<br /><br />
Hyödykkeen tuotantoon kohdistettavissa olevan lainan korkomeno tuotantojaksolta saadaan lukea hankintamenoon.
<br /><br />
Korkomenot voidaan lukea hankintamenoon, vaikka välillisiä menoja ei olisikaan aktivoitu. Hankintamenoon luettavien korkomenojen tulee ensisijaisesti koostua hankkeen rahoittamiseen otetusta lainasta.'"
            [unsaved]="data.tallentamattomat"
            [liitetiedot]="data.liitetiedot"
            (checkboxChanged)="checkboxChanged()"
          ></div>
          <div
            app-kirjanpito-liitetiedot-checkbox
            [formDisabled]="data.lukittu"
            (tallennaArvo)="tallennaMuuttunutArvo($event)"
            [parent]="osiot.PMA3_1_B"
            [field]="kentat.PMA3_1_B_2"
            [order]="2"
            [info]="'Verotuksessa hyväksyttävät enimmäispoistot 2021<br/><br/>
        <b>Irtain kuluva käyttöomaisuus</b>: Koneista, kalustosta ja muusta niihin verrattavasta irtaimesta käyttöomaisuudesta voi tehdä enintään <b>25 %:n poiston</b> menojäännöksestä.<br/><br/>
        <b>Rakennukset</b>: Myymälä-, tehdas-, varasto-, työpaja-, talous- ja muista näihin verrattavista rakennuksista voi tehdä enintään <b>7 %:n poiston</b>.<br/><br/>
        <b>Rakennukset</b>: toimisto-, asuin- ja muista näihin verrattavista rakennuksista <b>enimmäispoisto on 4 %</b>.<br/><br/>
        <b>Rakennukset ja rakennelmat</b>: Rakennuksista ja rakennelmista kuten säilöistä tai muista kevyistä rakennelmista tehtävä poisto on <b>20 %</b>.'"
            [example]="'Esim. Koneisiin ja kalustoon kirjatut tuotantolaitteet poistetaan 10% menojäännöspoistoin.'"
            [unsaved]="data.tallentamattomat"
            [liitetiedot]="data.liitetiedot"
            (checkboxChanged)="checkboxChanged()"
          ></div>
          <div
            app-kirjanpito-liitetiedot-checkbox
            [formDisabled]="data.lukittu"
            (tallennaArvo)="tallennaMuuttunutArvo($event)"
            [parent]="osiot.PMA3_1_B"
            [field]="kentat.PMA3_1_B_3"
            [order]="3"
            [info]="'Arvonkorotus tehdään nimensä mukaisesti korottamaan pysyviin vastaaviin kirjatun maa-alueen tai arvopaperin kirjanpitoarvoa lähemmäksi sen käypää arvoa. Arvonkorotuksen vastakirjaus on omassa pääomassa arvonkorotusrahasto. Arvonkorotusta ei pidä kuitenkaan sotkea kirjanpitosäännöstön sisältämiin säännöksiin käypään arvoon kirjaamisesta. Yritysten tilinpäätöksissä voi olla näkyvissä myös arvonkorotuksia, jotka on tehty vanhan lainsäädännön mukaan rakennuksiin. Tällä hetkellä arvonkorotus on mahdollista vain maa-alueisiin ja tiettyihin arvopapereihin, rakennusten osalta uusia arvonkorotuksia ei enää voi tehdä. Koska taseessa oleva arvonkorotus voi olla peruja vuosien takaa, on mahdollista, että se voi jäädä vuosien saatossa vaihtuvien järjestelmien ja toimijoiden takia piiloon.<br /><br />
        <a href=&quot;https://tilisanomat.fi/kolumnit/lyhyesta-virsi-kaunis-kolumnit/arvonkorotukset&quot; target=&quot;_blank&quot;>https://tilisanomat.fi/kolumnit/lyhyesta-virsi-kaunis-kolumnit/arvonkorotukset</a>'"
            [example]="'Esim. Pysyvien vastaavien maa-alueisiin on kirjattu arvonkorotus yhtiön omistaman kiinteistön maapohjan osalta. Muihin omaisuuseriin ei ole tehty arvonkorotuksia eikä arvonkorotusmahdollisuuksia ole selvitetty.
<br/><br />
Arvonkorotus on tehty perustuen kahdelta asiantuntijalta saatuihin kirjallisiin arvioihin, joiden keskiarviosta on varovaisuuden periaatteella huomioitu 80%. Arvioiden perusteella maa-alueen todennäköinen luovutushinta tilinpäätöspäivänä on pysyvästi alkuperäistä hankintamenoa olennaisesti suurempi. Arviot on päivitetty tilinpäätösajankohdalle. Maa- ja vesialueisiin on kirjattu näin johdettu maapohjan käypä arvo vähennettynä todennäköisillä luovutuskuluilla ja laskennallisella luovutuksesta aiheutuvalla tuloverolla. Arvonkorotusta tarkistetaan tilikausittain arvioidun käyvän arvon muuttuessa.'"
            [unsaved]="data.tallentamattomat"
            [liitetiedot]="data.liitetiedot"
            (checkboxChanged)="checkboxChanged()"
          ></div>
          <div
            app-kirjanpito-liitetiedot-checkbox
            [formDisabled]="data.lukittu"
            (tallennaArvo)="tallennaMuuttunutArvo($event)"
            [parent]="osiot.PMA3_1_B"
            [field]="kentat.PMA3_1_B_4"
            [order]="4"
            [info]="'Liitetieto on annettava jos saatuja avustuksia ei olla kirjattu hankintamenoksi vaan ne on käsitelty siirtovelkana.'"
            [unsaved]="data.tallentamattomat"
            [liitetiedot]="data.liitetiedot"
            (checkboxChanged)="checkboxChanged()"
          ></div>
          <div
            app-kirjanpito-liitetiedot-checkbox
            [formDisabled]="data.lukittu"
            (tallennaArvo)="tallennaMuuttunutArvo($event)"
            [parent]="osiot.PMA3_1_B"
            [field]="kentat.PMA3_1_B_5"
            [order]="5"
            [info]="'Lähtökohtaisesti vähäarvoiset hyödykkeet (á alle 1200€, yhteensä enintään 3600€) ja alle kolmen vuoden kalusto kirjataan kokonaan tilikauden kuluksi. Mikäli näitä menoja aktivoidaan taseeseen, tulee siitä mainita liitetiedoissa.'"
            [example]="'Esim. Yhtiön kannettavat tietokoneet, joiden todennäköinen käyttöikä on alle 3 vuotta, on aktivoitu taseeseen. Tilinpäätöshetkellä näin aktivoidun kaluston yhteisarvo oli 4 700 euroa.'"
            [unsaved]="data.tallentamattomat"
            [liitetiedot]="data.liitetiedot"
            (checkboxChanged)="checkboxChanged()"
          ></div>
          <div app-kirjanpito-liitetiedot-checkbox [formDisabled]="data.lukittu" (tallennaArvo)="tallennaMuuttunutArvo($event)" [parent]="osiot.PMA3_1_B" [field]="kentat.PMA3_1_B_6" [order]="6" [unsaved]="data.tallentamattomat" [liitetiedot]="data.liitetiedot" (checkboxChanged)="checkboxChanged()"></div>
          <div style="margin: 15px 0">{{ muiltaOsinTekstiObservable | async }}</div>
        </div>
        <div *ngTemplateOutlet="lisarivitTemplate; context: { data: data, osio: osiot.PMA3_1 }"></div>
        <h2 class="otsikko">
          {{ 'PMA3_2.title' | translatetilinpaatos: 2021 | async }}
          <!-- <button mat-icon-button style="vertical-align: top;" (click)="avaaInfoTeksti('Tässä on teksti')">
  <i class="icon ion-ios-information-circle-outline" style="font-size: 28px; color: gray;" aria-hidden="true"></i>
</button> -->
        </h2>
        <div style="padding: 0 15px">
          <div
            app-kirjanpito-liitetiedot-checkbox
            [formDisabled]="data.lukittu"
            (tallennaArvo)="tallennaMuuttunutArvo($event)"
            [parent]="osiot.PMA3_2"
            [field]="kentat.PMA3_2_1"
            [info]="'Poikkeuksellisiin eriin kirjataan yleensä sellaisia eriä, jotka eivät liity varsinaiseen liiketoimintaan. Liitetieto tulee antaa, koska tällainen erä vääristää yhtiön liikevoittoa ja ilman lisätietoa tilinpäätöksen lukija ei saa oikeaa ja riittävää kuvaa yrityksen tuloksesta ja taloudellisesta asemasta.'"
            [example]="'Esim. Yhtiö on saanut tilikauden aikana Valtionkonttorin kustannustukea yhteensä 20 000 euroa, joka on kirjattu liiketoiminnan muihin tuottoihin.'"
            [unsaved]="data.tallentamattomat"
            [liitetiedot]="data.liitetiedot"
            (checkboxChanged)="checkboxChanged()"
          ></div>
        </div>
        <div *ngTemplateOutlet="lisarivitTemplate; context: { data: data, osio: osiot.PMA3_2 }"></div>
        <h2 class="otsikko">
          {{ 'PMA3_3.title' | translatetilinpaatos: 2021 | async }}
          <!-- <button mat-icon-button style="vertical-align: top;" (click)="avaaInfoTeksti('Tässä on teksti')">
  <i class="icon ion-ios-information-circle-outline" style="font-size: 28px; color: gray;" aria-hidden="true"></i>
</button> -->
        </h2>
        <div style="padding: 0 15px">
          <div
            app-kirjanpito-liitetiedot-checkbox
            [formDisabled]="data.lukittu"
            (tallennaArvo)="tallennaMuuttunutArvo($event)"
            [parent]="osiot.PMA3_3"
            [field]="kentat.PMA3_3_1"
            [info]="'Tilikauden jälkeiset olennaiset tapahtumat kohdassa tulisi ilmoittaa kaikki sellaiset olennaiset asiat, jotka ovat tiedossa tilinpäätöstä laadittaessa, eikä vain niitä asioita, jotka ovat tapahtuneet tilikauden viimeiseen päivään mennessä.'"
            [example]="'Esim. Yhtiö on tilikauden päättymisen jälkeen lakkauttanut yhden toimipisteensä kannattamattomuuden vuoksi. Toimipisteen osuus päättyneen tilikauden liikevaihdosta oli noin 5%.'"
            [unsaved]="data.tallentamattomat"
            [liitetiedot]="data.liitetiedot"
            (checkboxChanged)="checkboxChanged()"
          ></div>
        </div>
        <div *ngTemplateOutlet="lisarivitTemplate; context: { data: data, osio: osiot.PMA3_3 }"></div>
        <h2 class="otsikko">
          {{ 'PMA3_4.title' | translatetilinpaatos: 2021 | async }}
          <!-- <button mat-icon-button style="vertical-align: top;" (click)="avaaInfoTeksti('Tässä on teksti')">
  <i class="icon ion-ios-information-circle-outline" style="font-size: 28px; color: gray;" aria-hidden="true"></i>
</button> -->
        </h2>
        <div style="padding: 0 15px">
          <div
            app-kirjanpito-liitetiedot-checkbox
            [formDisabled]="data.lukittu"
            (tallennaArvo)="tallennaMuuttunutArvo($event)"
            [parent]="osiot.PMA3_4"
            [field]="kentat.PMA3_4_1"
            [info]="'Jos pysyviin vastaaviin kuuluva maa- tai vesialue tai arvopaperi (<span style=&quot;color: red;&quot;>ei rahoitusarvopaperi tai johdannaissopimus, muun päätelmä KPL 5 §2a</span>) on tilinpäätöspäivänä pysyvästi alkuperäistä hankitamenoa olennaisesti suurempi, saadaan taseeseen varovaisuutta noudattaen merkitä arvonkorotus. Korotus on suuruudeltaan poistamatta olevan hankitamenon ja todennäköisen luovutushinnan suuruinen erotus.'"
            [example]="'Esim.
<br /><br />
1) Arvonkorotusrahaston muutokset tilikauden aikana

<table style=&quot;margin-left: 25px;&quot;>
  <tr>
    <th>Kohde</th>
    <th>Alkusaldo</th>
    <th>Lisäys</th>
    <th>Vähennys</th>
    <th>Loppusaldo</th>
    <th>Verovaikutus/<br/>laskennallinen verovelka</th>
  </tr>
  <tr>
    <td>Sijoitukset/<br/>muut osakkeet ja osuudet</td>
    <td style=&quot;text-align:right;&quot;>0,00</td>
    <td style=&quot;text-align:right;&quot;>40 000,00</td>
    <td style=&quot;text-align:right;&quot;>0,00</td>
    <td style=&quot;text-align:right;&quot;>40 000,00</td>
    <td style=&quot;text-align:right;&quot;>8 000,00</td>
  </tr>
</table>
<br />
2) Selvitys arvonkorotusrahaston muutoksiin liittyvistä verovaikutuksista
<div style=&quot;margin-left: 25px;&quot;>
Taseeseen sisältyvä 40 000,00 euron suuruinen arvonkorotus ei vaikuta tilikauden verotettavaa tuloon. Arvonkorotuksessa on otettu huomioon todennäköisesti luovutushinnasta varovaisuuden periaatteella johdetun käyvän arvon ja alkuperäisen hankitamenon erotus väehnnettynä todennäköisillä luovutuskuluilla. Laskennallinen
voimassa olevan yhteisöverokannan mukainen verovelka on suuruudeltaan 8 000,00 euroa.
</div>
<br />
3) Arvonkorotuksen kohteiden yhteenlaskettu kirjanpitoarvo ennen arvonkorotusta
<div style=&quot;margin-left: 25px;&quot;>
Pysyvien vastaavien sijoitusten osakkeiden ja osuuksien sisältämien asuinhuoneiston hallintaan oikeuttavien osakkeiden kirjanpitoarvo on tilinpäätöksessä 243 000,00 euroa. Kirjanpitoarvo ennen arvonkorotusta oli 203 000,00 euroa.
</div>
'"
            [unsaved]="data.tallentamattomat"
            [liitetiedot]="data.liitetiedot"
            (checkboxChanged)="checkboxChanged()"
          ></div>
        </div>
        <div *ngTemplateOutlet="lisarivitTemplate; context: { data: data, osio: osiot.PMA3_4 }"></div>
        <h2 class="otsikko">
          {{ 'PMA3_6.title' | translatetilinpaatos: 2021 | async }}
          <!-- <button mat-icon-button style="vertical-align: top;" (click)="avaaInfoTeksti('Tässä on teksti')">
  <i class="icon ion-ios-information-circle-outline" style="font-size: 28px; color: gray;" aria-hidden="true"></i>
</button> -->
        </h2>
        <div style="padding: 0 15px">
          <div
            app-kirjanpito-liitetiedot-checkbox
            [formDisabled]="data.lukittu"
            (tallennaArvo)="tallennaMuuttunutArvo($event)"
            [parent]="osiot.PMA3_6"
            [field]="kentat.PMA3_6_1"
            [info]="'Liitetietona on esitettävä yhteenlaskettu määrä sellaisista pitkäaikaiseen vieraaseen pääomaan kuuluvista veloista, jotka erääntyvät myöhemmin kuin viiden vuoden kuluttua.'"
            [example]="'Esim. Pitkäaikaiseen vieraaseen pääomaan sisältyy 15 000,00 euroa velkoja, jotka erääntyvät myöhemmin kuin viiden vuoden kuluttua.'"
            [unsaved]="data.tallentamattomat"
            [liitetiedot]="data.liitetiedot"
            (checkboxChanged)="checkboxChanged()"
          ></div>
        </div>
        <div *ngTemplateOutlet="lisarivitTemplate; context: { data: data, osio: osiot.PMA3_6 }"></div>
        <h2 class="otsikko">
          {{ 'PMA3_7.title' | translatetilinpaatos: 2021 | async }}
          <!-- <button mat-icon-button style="vertical-align: top;" (click)="avaaInfoTeksti('Tässä on teksti')">
  <i class="icon ion-ios-information-circle-outline" style="font-size: 28px; color: gray;" aria-hidden="true"></i>
</button> -->
        </h2>
        <div style="padding: 0 15px">
          <div
            app-kirjanpito-liitetiedot-checkbox
            [formDisabled]="data.lukittu"
            (tallennaArvo)="tallennaMuuttunutArvo($event)"
            [parent]="osiot.PMA3_7"
            [field]="kentat.PMA3_7_1"
            [order]="1"
            [unsaved]="data.tallentamattomat"
            [info]="'Yrityksen antamat vakuudet joko oman lainansa vakuutena tai esimerkiksi emoyhtiön/tytäryhtiön lainan vakuudeksi annettu pantti. Vakuuksia voi olla esim. käteispantti, kiinteistökiinnitys, ajoneuvokiinnitys tai yrityskiinnitys. Jos velka on pienempi kuin annetun vakuuden määrä, vakuus esitetään velan määrän mukaisena (eli valitaan pienempi).'"
            [example]="'Esim. Yhtiö on antanut vakuuksia seuraavasti:
<table style=&quot;margin-left:25px;margin-top:10px;&quot;>
  <tr>
    <td>yrityskiinnitys</td>
    <td>20 000,00€</td>
    <td>emoyhtiön puolesta</td>
  </tr>
  <tr>
    <td>käteispantti</td>
    <td>10 000,00€</td>
    <td>oman yhtiön puolesta</td>
  </tr>
  <tr>
    <td>Vuokravakuus</td>
    <td>5 000,00€</td>
    <td>oman yhtiön puolesta</td>
  </tr>
</table>
'"
            [liitetiedot]="data.liitetiedot"
            (checkboxChanged)="checkboxChanged()"
          ></div>
          <div
            app-kirjanpito-liitetiedot-checkbox
            [formDisabled]="data.lukittu"
            (tallennaArvo)="tallennaMuuttunutArvo($event)"
            [parent]="osiot.PMA3_7"
            [field]="kentat.PMA3_7_2"
            [order]="2"
            [info]="'Taseen ulkopuolisia taloudellisisia sitoumuksia (vastuita) voi olla esim.
<ul>
  <li>määräaikaisen vuokrasopimuksen jäljellä oleva vuokravastuu</li>
  <li>leasingvuokran jäljellä oleva vuokrasumma sekä jäännösarvo</li>
  <li>vireillä olevan oikeudenkäynnin mahdollisesti tuottama korvausvastuu</li>
</ul>
'"
            [example]="'Esim. Taseen ulkopuolisten vastuiden yhteismäärä on 75 000 euroa.'"
            [unsaved]="data.tallentamattomat"
            [liitetiedot]="data.liitetiedot"
            (checkboxChanged)="checkboxChanged()"
          ></div>
          <div
            app-kirjanpito-liitetiedot-checkbox
            [formDisabled]="data.lukittu"
            (tallennaArvo)="tallennaMuuttunutArvo($event)"
            [parent]="osiot.PMA3_7"
            [field]="kentat.PMA3_7_3"
            [order]="3"
            [info]="'Mikäli kohdassa 2) on annettu vastuiden yhteismäärä, pitää antaa lisätiedot jos järjestelyistä aiheutuvat riskit ja hyödyt ovat olennaisia ja <b>jos</b> niitä koskeva tieto on välttämätön pienyrityksen taloudellisen aseman arvioimista varten.'"
            [example]="'Esim. Yllä esitettyyn taseen ulkopuolisten vastuiden yhteismäärään sisältyy:
<ul>
  <li>määräaikaisen vuokrasopimuksen jäljellä oleva vuokravastuu</li>
  <li>leasingvuokran avoin vuokravastuu sekä jäännösarvovastuu</li>
</ul>
'"
            [unsaved]="data.tallentamattomat"
            [liitetiedot]="data.liitetiedot"
            (checkboxChanged)="checkboxChanged()"
          ></div>
          <div app-kirjanpito-liitetiedot-checkbox [formDisabled]="data.lukittu" (tallennaArvo)="tallennaMuuttunutArvo($event)" [parent]="osiot.PMA3_7" [field]="kentat.PMA3_7_4" [order]="4" [unsaved]="data.tallentamattomat" [liitetiedot]="data.liitetiedot" (checkboxChanged)="checkboxChanged()"></div>
        </div>
        <div *ngTemplateOutlet="lisarivitTemplate; context: { data: data, osio: osiot.PMA3_7 }"></div>
        <h2 class="otsikko">
          {{ 'PMA3_8.title' | translatetilinpaatos: 2021 | async }}
          <!-- <button mat-icon-button style="vertical-align: top;" (click)="avaaInfoTeksti('')">
  <i class="icon ion-ios-information-circle-outline" style="font-size: 28px; color: gray;" aria-hidden="true"></i>
</button> -->
        </h2>
        <div style="padding: 0 15px">
          <div
            app-kirjanpito-liitetiedot-checkbox
            [formDisabled]="data.lukittu"
            (tallennaArvo)="tallennaMuuttunutArvo($event)"
            [parent]="osiot.PMA3_8"
            [field]="kentat.PMA3_8_1"
            [info]="'Liitetietona on esitettävä emoyrityksen nimi ja kotipaikka siitä konsernitilinpäätöksen kohteena olevasta konsernista, johon pienyritys välittömimmin kuuluu.'"
            [example]="'Esim: Emoyrityksen tiedot:
<table>
  <tr>
    <td>Nimi:</td>
    <td>Emoyritys Oy</td>
  </tr>
  <tr>
    <td>Kotipaikka:</td>
    <td>Helsinki</td>
  </tr>
</table>
'"
            [unsaved]="data.tallentamattomat"
            [liitetiedot]="data.liitetiedot"
            (checkboxChanged)="checkboxChanged()"
          ></div>
        </div>
        <div *ngTemplateOutlet="lisarivitTemplate; context: { data: data, osio: osiot.PMA3_8 }"></div>
        <h2 class="otsikko">
          {{ 'PMA3_9.title' | translatetilinpaatos: 2021 | async }}
          <!-- <button mat-icon-button style="vertical-align: top;" (click)="avaaInfoTeksti('')">
  <i class="icon ion-ios-information-circle-outline" style="font-size: 28px; color: gray;" aria-hidden="true"></i>
</button> -->
        </h2>
        <div style="padding: 0 15px">
          <div
            app-kirjanpito-liitetiedot-checkbox
            [formDisabled]="data.lukittu"
            (tallennaArvo)="tallennaMuuttunutArvo($event)"
            [parent]="osiot.PMA3_9"
            [field]="kentat.PMA3_9_1"
            [info]="'Toimitusjohtajasta, hallituksen jäsenistä ja varajäsenistä sekä vastaaviin toimielimiin kuuluvista henkilöistä on ilmoitettava toimielinkohtaisena liitetietona seuraavat:
<ol>
  <li>Toimitusjohtajille ja hallintoelimiin kuuluville annetut lainat</li>
  <li>Intressitahojen puolesta annetut vakuudet ja vastuusitoumukset</li>
  <li>Eläkesitoumukset näistä tehtävistä</li>
</ol>
'"
            [example]="'Esim. Toimitusjohtajille ja hallintoelimiin kuuluville annetut lainat

<table style=&quot;margin-left:25px;margin-top:10px;&quot;>
  <tr>
    <th>Saaja</th>
    <th>Muutos</th>
    <th>Saldo</th>
    <th>Vakuus</th>
    <th>Laina-aika</th>
    <th>Korko</th>
  </tr>
  <tr>
    <td>toimitusjohtaja</td>
    <td style=&quot;text-align:right;&quot;>+5 000,00</td>
    <td style=&quot;text-align:right;&quot;>5 000,00</td>
    <td>osakepantti</td>
    <td>5 vuotta</td>
    <td>VM:n peruskorko +1%</td>
  </tr>
  <tr>
    <td>hallituksen varajäsen</td>
    <td style=&quot;text-align:right;&quot;>+1 000,00</td>
    <td style=&quot;text-align:right;&quot;>1 000,00</td>
    <td>esinepantti</td>
    <td>1 vuosi</td>
    <td>VM:n peruskorko</td>
  </tr>
</table>
<div style=&quot;margin-top:10px;&quot;>Intressitahojen puolesta annetut vakuudet ja vastuusitoumukset</div>
<table style=&quot;margin-left:25px;margin-top:10px;&quot;>
  <tr>
    <th>Edunsaaja</th>
    <th>Määrä</th>
    <th>Vakuuden / vastuusitoumuksen tyyppi</th>
  </tr>
  <tr>
    <td>toimitusjohtaja</td>
    <td style=&quot;text-align:right;&quot;>60 000,00</td>
    <td>yrityskiinnitys vakuutena rahoituslaitoslainalle</td>
  </tr>
</table>
'"
            [unsaved]="data.tallentamattomat"
            [liitetiedot]="data.liitetiedot"
            (checkboxChanged)="checkboxChanged()"
          ></div>
        </div>
        <div *ngTemplateOutlet="lisarivitTemplate; context: { data: data, osio: osiot.PMA3_9 }"></div>
        <h2 class="otsikko">
          {{ 'PMA3_10.title' | translatetilinpaatos: 2021 | async }}
          <!-- <button mat-icon-button style="vertical-align: top;" (click)="avaaInfoTeksti('Tässä on teksti')">
  <i class="icon ion-ios-information-circle-outline" style="font-size: 28px; color: gray;" aria-hidden="true"></i>
</button> -->
        </h2>
        <div style="padding: 0 15px">
          <div
            app-kirjanpito-liitetiedot-checkbox
            [formDisabled]="data.lukittu"
            (tallennaArvo)="tallennaMuuttunutArvo($event)"
            [parent]="osiot.PMA3_10"
            [field]="kentat.PMA3_10_1"
            [info]="'Liitetietona on esitettävä tiedot pienyrityksen ja tämän intressitahoihin kuuluvien välisistä liiketoimista, jos ne ovat olennaisia eikä niitä ole toteutettu tavanomaisin kaupallisin ehdoin.

Intressitahoilla tarkoitetaan kirjanpitovelvollisen kanssa määräysvalta- tai osakkuusyrityssuhteessa olevaa oikeushenkilöä. Intressitahoiksi luetaan myös toimitusjohtaja, hallituksen varsinaiset ja varajäsenet sekä vastaaviin hallintoelimiin kuuluvat henkilöt.

Intressitahoon liittyvästä toimesta esitettäviin tietoihin tulee sisältyä:
<ol>
  <li>kuvaus liiketoimesta;</li>
  <li>liiketoimen arvo;</li>
  <li>intressisuhteen luonne; sekä</li>
  <li>muut yrityksen taloudellisen aseman arvioimisen kannalta välttämättömät tiedot liiketoimesta.</li>
</ol>'"
            [example]="'Esim: Tytäryritys Oy:lle on tilikaudella myyty Emoyritys Oy:n tavanomaiseen liiketoimintaan kuuluvia tuotteita ja palveluja. Tuotteiden ja palvelujen myynnissä on käytetty 365 päivän maksuaikaa, joka poikkeaa Emoyritys Oy:n tavanomaisesti käyttämästä 30 päivän maksuajasta. Tilikauden aikana tällaisia myyntisaamisia on kirjattu yhteensä 100 000,00 euroa, joista 20 000,00 euroa on avoimena taseessa. Tytäryritys Oy on Emoyritys Oy:n kokonaan omistama tytäryhtiö.

Huom! Yllä olevassa ei oteta kantaa siihen, ovatko kuvatut liiketoimet säännösten ja määräysten mukaisia tai muutoin hyväksyttäviä.'"
            [unsaved]="data.tallentamattomat"
            [liitetiedot]="data.liitetiedot"
            (checkboxChanged)="checkboxChanged()"
          ></div>
        </div>
        <div *ngTemplateOutlet="lisarivitTemplate; context: { data: data, osio: osiot.PMA3_10 }"></div>
        <h2 class="otsikko">
          {{ 'PMA3_11.title' | translatetilinpaatos: 2021 | async }}
          <app-icon-button
            (click)="
              avaaInfoTeksti(
                'Henkilöstön lukumäärä lasketaan usein kokotyökuukausien mukaan.
Tärkeää on, että henkilöstön määrä lasketaan vuosittain saman kaavan mukaisesti, eikä laskentatapa vaihdu tilikausittain. Henkilöstön määrä vaikuttaa mm. tilintarkastusrajoihin, joten niiden suhteen kannattaa olla tarkkana ja epäselvissä tapauksissa pyytää asiakkaalta vahvistus.'
              )
            "
            actionId="Avaa info teksti (liitetiedot)"
            styles="vertical-align: top;"
          >
            <i class="icon ion-ios-information-circle-outline" style="font-size: 28px; color: gray" aria-hidden="true"></i>
          </app-icon-button>
        </h2>
        <div style="padding: 0 15px">
          <mat-checkbox class="cb keskitetty-label" [formField]="lomake.henkilostonMaaraValittu">
            {{ 'PMA3_11.keskimaarainen-lukumaara-start' | translatetilinpaatos: 2021 | async }}
            <mat-form-field style="width: 60px; height: 48px">
              <input
                #henkilostonMaaraInput
                class="skip-space-quick-toggle"
                decimalNumberField
                type="text"
                [numberOfDecimals]="0"
                [formField]="lomake.henkilostonMaara"
                (input)="numeroMuuttui(lomake.henkilostonMaara().value(), kentat.PMA3_11_1)"
                (change)="numeroMuuttui(lomake.henkilostonMaara().value(), kentat.PMA3_11_1)"
                (blur)="tallennaNumero(kentat.PMA3_11_1)"
                (appOnDisabled)="henkilostonMaaraInputDisabledChanged($event)"
                matInput
                data-lpignore="true"
              />
            </mat-form-field>
            {{ 'PMA3_11.keskimaarainen-lukumaara-end' | translatetilinpaatos: 2021 | async }} </mat-checkbox
          ><br />
        </div>
        <div *ngTemplateOutlet="lisarivitTemplate; context: { data: data, osio: osiot.PMA3_11 }"></div>
        <h2 class="otsikko">
          {{ 'PMA3_12.title' | translatetilinpaatos: 2021 | async }}
          <!-- <button mat-icon-button style="vertical-align: top;" (click)="avaaInfoTeksti('')">
  <i class="icon ion-ios-information-circle-outline" style="font-size: 28px; color: gray;" aria-hidden="true"></i>
</button> -->
        </h2>
        <div style="padding: 0 15px">
          <div
            app-kirjanpito-liitetiedot-checkbox
            [formDisabled]="data.lukittu"
            (tallennaArvo)="tallennaMuuttunutArvo($event)"
            [parent]="osiot.PMA3_12"
            [field]="kentat.PMA3_12_1"
            [info]="'Liitetietona on esitettävä:
<ol>
  <li>tilikauden aikana tehtyjen omien osakkeiden tai osakkeita vastaavien oman pääoman ehtoisten osuuksien (omat osuudet) hankintojen perusteet;</li>
  <li>tilikauden aikana hankittujen tai luovutettujen omien osuuksien lukumäärä ja nimellisarvo tai, jos nimellisarvoa ei ole, kirjanpidollinen vasta-arvo sekä suhteellinen osuus, jota omat osuudet edustavat merkitystä omasta pääomasta;</li>
  <li>vastikkeellisissa hankinnoissa tai luovutuksissa omista osuuksista suoritettu vastike; sekä</li>
  <li>yrityksen hankkimien ja sen hallussa olevien kaikkien omien osuuksien lukumäärä ja nimellisarvo tai, jos nimellisarvoa ei ole, kirjanpidollinen vasta-arvo sekä suhteellinen osuus, jota omat osuudet edustavat merkitystä pääomasta.</li>
</ol>'"
            [unsaved]="data.tallentamattomat"
            [liitetiedot]="data.liitetiedot"
            (checkboxChanged)="checkboxChanged()"
          ></div>
        </div>

        <div *ngTemplateOutlet="lisarivitTemplate; context: { data: data, osio: osiot.PMA3_12 }"></div>

        <h2 class="otsikko">
          {{ 'MUUT.title' | translatetilinpaatos: 2021 | async }}
          <app-icon-button (click)="avaaInfoTeksti('Vapaamuotoiset lisätiedot.')" actionId="Avaa infoteksti" styles="vertical-align: top;">
            <i class="icon ion-ios-information-circle-outline" style="font-size: 28px; color: gray" aria-hidden="true"></i>
          </app-icon-button>
        </h2>
        <div class="lisatiedot-status">
          @if (lisatiedotSaveSuccessObservable | async) {
            <span>
              <span class="save-success-text" [@quickInSlowOut]="'in'" style="color: gray"> Arvot tallennettiin </span>
              <mat-icon class="save-success-icon" [@quickInSlowOut]="'in'" [ngStyle]="{ color: '#4bd76b', 'vertical-align': 'middle' }">done</mat-icon>
            </span>
          }
        </div>
        <div class="lisatiedot">
          @for (lisatieto of data.liitetiedot.lisatietokentat; track trackByTunnus(index, lisatieto); let index = $index) {
            @if (!lisatieto.poistettu) {
              <div class="lisatieto">
                <div class="lisatieto-otsikko">
                  <textarea placeholder="Otsikko" cdkAutosizeMaxRows="1" matInput style="width: 100%; border: 1px solid gray; padding: 5px; font-weight: bold" (blur)="tallennaLisatiedot()" [formField]="lisatietojenOtsikot.kentta(lisatieto.tunnus)" (input)="lisatietoMuuttui($any($event.target).value, lisatieto, 'otsikko')" cdkTextareaAutosize></textarea>
                  <app-icon-button (click)="poistaLisatieto(lisatieto)" actionId="Avasi dialogin: Poista lisätieto (liitetiedot)" styles="vertical-align: top;">
                    <i class="icon ion-ios-trash icon-btn" style="font-size: 24px; color: gray" aria-hidden="true"></i>
                  </app-icon-button>
                </div>
                <textarea placeholder="Teksti" matInput style="width: 100%; border: 1px dashed gray; padding: 5px" (blur)="tallennaLisatiedot()" [formField]="lisatietojenTekstit.kentta(lisatieto.tunnus)" (input)="lisatietoMuuttui($any($event.target).value, lisatieto, 'teksti')" cdkTextareaAutosize></textarea>
              </div>
            }
          }
          <app-button (click)="lisaaLisatieto()" actionId="Avaa lisätieto täytettäväksi (liitetiedot)" additionalClass="add-btn" matIcon="add"> Lisää lisätieto </app-button>
        </div>

        <h2 class="otsikko">
          {{ 'PMA4_4_2.title' | translatetilinpaatos: 2021 | async }}
          <!-- <button mat-icon-button style="vertical-align: top;" (click)="avaaInfoTeksti('Tässä on teksti')">
          <i class="icon ion-ios-information-circle-outline" style="font-size: 28px; color: gray;" aria-hidden="true"></i>
        </button> -->
        </h2>
        <div style="margin: 15px 0; font-size: 120%; font-weight: bold">{{ 'oman-paaoman-muutokset' | translatetilinpaatos: 2021 | async }}</div>

        <div style="padding: 0 15px">
          <div style="background-color: #f2f2f2; padding: 15px">
            @if (data.liitetiedot.vertailutiedot !== 'aikaisemmasta') {
              <div>
                <label [class.mat-form-field-invalid]="lomake.vertailutiedot().touched() && onkoVirhe(lomake.vertailutiedot, 'required')" style="margin-bottom: 5px; display: block" id="ei-edellisia-vertailuarvoja-radio-group-label">Edellisen tilikauden vertailutietoja ei löytynyt. Valitse:</label>
                <mat-radio-group aria-labelledby="ei-edellisia-vertailuarvoja-radio-group-label" [formField]="lomake.vertailutiedot">
                  <mat-radio-button [value]="'ensimmainen-tilikausi'">{{ 'PMA4_4_2.yhtion-ensimmainen' | translatetilinpaatos: 2021 | async }}</mat-radio-button
                  ><br />
                  <mat-radio-button [value]="'syotetaan-kasin'">{{ 'PMA4_4_2.on aiempia' | translatetilinpaatos: 2021 | async }}</mat-radio-button>
                </mat-radio-group>
                @if (lomake.vertailutiedot().touched() && onkoVirhe(lomake.vertailutiedot, 'required')) {
                  <mat-error>Tieto vertailutiedoista puuttuu.</mat-error>
                }
              </div>
            }
            @if (data.liitetiedot.vertailutiedot) {
              @if (data.liitetiedot.vertailutiedot === 'syotetaan-kasin') {
                <div style="padding-left: 3.5em; padding-top: 2em; padding-bottom: 2em">
                  <table class="laskelmat-table edit-table">
                    <thead>
                      <tr>
                        <th style="width: unset; text-align: left">Syötä edellisen kauden vertailutiedot käsin</th>
                        <!-- <th style="width: 100px;">{{data.liitetiedot.omanPaaomanMuutoksetLaskelma.header}}</th> -->
                        <th style="width: 100px">{{ data.liitetiedot.omanPaaomanMuutoksetVertailulaskelma.header }}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>{{ 'osakepaaoma-tilikauden-alussa' | translatetilinpaatos: 2021 | async }}</td>
                        <!-- <td>{{data.liitetiedot.omanPaaomanMuutoksetLaskelma.osakepaaomaTilikaudenAlussa | number:'1.2-2'}}</td> -->
                        <td>
                          <mat-form-field>
                            <input decimalNumberField class="skip-space-quick-toggle" type="text" [formField]="lomake.vertailulaskelma.osakepaaomaTilikaudenAlussa" (input)="vertailuarvoSyotetty(data, 'osakepaaomaTilikaudenAlussa')" (change)="vertailuarvoSyotetty(data, 'osakepaaomaTilikaudenAlussa')" (blur)="tallennaVertailuarvot()" matInput data-lpignore="true" />
                          </mat-form-field>
                        </td>
                      </tr>
                      <tr>
                        <td>Osakeanti</td>
                        <!-- <td>{{data.liitetiedot.omanPaaomanMuutoksetLaskelma.osakeanti | number:'1.2-2'}}</td> -->
                        <td>
                          <mat-form-field>
                            <input decimalNumberField class="skip-space-quick-toggle" type="text" [formField]="lomake.vertailulaskelma.osakeanti" (input)="vertailuarvoSyotetty(data, 'osakeanti')" (change)="vertailuarvoSyotetty(data, 'osakeanti')" (blur)="tallennaVertailuarvot()" matInput data-lpignore="true" />
                          </mat-form-field>
                        </td>
                      </tr>
                      <tr>
                        <td>Muut pääoman ehtoiset erät</td>
                        <td>
                          <mat-form-field>
                            <input decimalNumberField class="skip-space-quick-toggle" type="text" [formField]="lomake.vertailulaskelma.muutPaaomanEhtoisiinErat" (input)="vertailuarvoSyotetty(data, 'muutPaaomanEhtoisiinErat')" (change)="vertailuarvoSyotetty(data, 'muutPaaomanEhtoisiinErat')" (blur)="tallennaVertailuarvot()" matInput data-lpignore="true" />
                          </mat-form-field>
                        </td>
                      </tr>
                      <!-- <tr>
              <td>Osakepääoma tilikauden lopussa</td>
              <td>{{data.liitetiedot.omanPaaomanMuutoksetLaskelma.osakepaaomaTilikaudenLopussa | number:'1.2-2'}}</td>
              <td>{{data.liitetiedot.omanPaaomanMuutoksetVertailulaskelma.osakepaaomaTilikaudenLopussa | number:'1.2-2'}}</td>
            </tr>
            <tr>
              <td>Sidottu oma pääoma</td>
              <td>{{data.liitetiedot.omanPaaomanMuutoksetLaskelma.sidottuOmaPaaoma | number:'1.2-2'}}</td>
              <td>{{data.liitetiedot.omanPaaomanMuutoksetVertailulaskelma.sidottuOmaPaaoma | number:'1.2-2'}}</td>
            </tr> -->
                      <tr>
                        <td>Sijoitetun vapaan oman pääoman rahasto tilikauden alussa</td>
                        <!-- <td>{{data.liitetiedot.omanPaaomanMuutoksetLaskelma.svopTilikaudenAlussa | number:'1.2-2'}}</td> -->
                        <td>
                          <mat-form-field>
                            <input decimalNumberField class="skip-space-quick-toggle" type="text" [formField]="lomake.vertailulaskelma.svopTilikaudenAlussa" (input)="vertailuarvoSyotetty(data, 'svopTilikaudenAlussa')" (change)="vertailuarvoSyotetty(data, 'svopTilikaudenAlussa')" (blur)="tallennaVertailuarvot()" matInput data-lpignore="true" />
                          </mat-form-field>
                        </td>
                      </tr>
                      <tr>
                        <td>Sijoitetun vapaan oman pääoman rahaston lisäykset tilikaudella</td>
                        <!-- <td>{{data.liitetiedot.omanPaaomanMuutoksetLaskelma.svopLisayksetTilikaudenAikana | number:'1.2-2'}}</td> -->
                        <td>
                          <mat-form-field>
                            <input decimalNumberField class="skip-space-quick-toggle" type="text" [formField]="lomake.vertailulaskelma.svopLisayksetTilikaudenAikana" (input)="vertailuarvoSyotetty(data, 'svopLisayksetTilikaudenAikana')" (change)="vertailuarvoSyotetty(data, 'svopLisayksetTilikaudenAikana')" (blur)="tallennaVertailuarvot()" matInput data-lpignore="true" />
                          </mat-form-field>
                        </td>
                      </tr>
                      <tr>
                        <td>Sijoitetun vapaan oman pääoman rahaston vähennykset tilikaudella</td>
                        <!-- <td>{{data.liitetiedot.omanPaaomanMuutoksetLaskelma.svopLisayksetTilikaudenAikana | number:'1.2-2'}}</td> -->
                        <td>
                          <mat-form-field>
                            <input matInput decimalNumberField class="skip-space-quick-toggle" type="text" [formField]="lomake.vertailulaskelma.svopVahennyksetTilikaudenAikana" (input)="vertailuarvoSyotetty(data, 'svopVahennyksetTilikaudenAikana')" (change)="vertailuarvoSyotetty(data, 'svopVahennyksetTilikaudenAikana')" (blur)="tallennaVertailuarvot()" matInput data-lpignore="true" />
                          </mat-form-field>
                        </td>
                      </tr>
                      <!-- <tr>
            <td>Sijoitetun vapaan oman pääoman rahasto tilikauden lopussa</td>
            <td>{{data.liitetiedot.omanPaaomanMuutoksetLaskelma.svopTilikaudenLopussa | number:'1.2-2'}}</td>
            <td>{{data.liitetiedot.omanPaaomanMuutoksetVertailulaskelma.svopTilikaudenLopussa | number:'1.2-2'}}</td>
          </tr> -->
                      <tr>
                        <td>Edellisten tilikausien voitto (tappio) tilikauden alussa</td>
                        <!-- <td>{{data.liitetiedot.omanPaaomanMuutoksetLaskelma.edellistenTilikausienVoittoTaiTappioTilikaudenAlussa | number:'1.2-2'}}</td> -->
                        <td>
                          <mat-form-field>
                            <input
                              decimalNumberField
                              class="skip-space-quick-toggle"
                              type="text"
                              [formField]="lomake.vertailulaskelma.edellistenTilikausienVoittoTaiTappioTilikaudenAlussa"
                              (input)="vertailuarvoSyotetty(data, 'edellistenTilikausienVoittoTaiTappioTilikaudenAlussa')"
                              (change)="vertailuarvoSyotetty(data, 'edellistenTilikausienVoittoTaiTappioTilikaudenAlussa')"
                              (blur)="tallennaVertailuarvot()"
                              matInput
                              data-lpignore="true"
                            />
                          </mat-form-field>
                        </td>
                      </tr>
                      <tr>
                        <td>Osingonjako tilikaudella</td>
                        <!-- <td>{{data.liitetiedot.omanPaaomanMuutoksetLaskelma.osingonjakoTilikaudella | number:'1.2-2'}}</td> -->
                        <td>
                          <mat-form-field>
                            <input decimalNumberField class="skip-space-quick-toggle" type="text" [formField]="lomake.vertailulaskelma.osingonjakoTilikaudella" (input)="vertailuarvoSyotetty(data, 'osingonjakoTilikaudella')" (change)="vertailuarvoSyotetty(data, 'osingonjakoTilikaudella')" (blur)="tallennaVertailuarvot()" matInput data-lpignore="true" />
                          </mat-form-field>
                        </td>
                      </tr>
                      <!-- <tr>
          <td>Tilikaudella hankitut omat osakkeet</td>
          <td>
            <mat-form-field>
              <input [disabled]="data.lukittu" decimalNumberField class="skip-space-quick-toggle" type="text" [ngModel]="data.liitetiedot.omanPaaomanMuutoksetVertailulaskelma.tiikaudellaOstetutOmatOsakkeet" (ngModelChange)="data.tallentamattomat.omanPaaomanMuutoksetVertailulaskelma.tiikaudellaOstetutOmatOsakkeet = $event; vertailuarvoMuuttui()" (blur)="tallennaVertailuarvot()" [name]="'a14' + namename" matInput
                data-lpignore="true" />
            </mat-form-field>
          </td>
        </tr>
        <tr>
          <td>Tilikaudella luovutetut omat osakkeet</td>
          <td>
            <mat-form-field>
              <input [disabled]="data.lukittu" decimalNumberField class="skip-space-quick-toggle" type="text" [ngModel]="data.liitetiedot.omanPaaomanMuutoksetVertailulaskelma.tilikaudellaMyydytOmatOsakkeet" (ngModelChange)="data.tallentamattomat.omanPaaomanMuutoksetVertailulaskelma.tilikaudellaMyydytOmatOsakkeet = $event; vertailuarvoMuuttui()" (blur)="tallennaVertailuarvot()" [name]="'a15' + namename" matInput
                data-lpignore="true" />
            </mat-form-field>
          </td>
        </tr> -->
                      <!-- <tr>
        <td>Edellisten tilikausien voitto (tappio) tilikauden lopussa</td>
        <td>{{data.liitetiedot.omanPaaomanMuutoksetLaskelma.edellistenTilikausienVoittoTaiTappioTilikaudenLopussa | number:'1.2-2'}}</td>
        <td>{{data.liitetiedot.omanPaaomanMuutoksetVertailulaskelma.edellistenTilikausienVoittoTaiTappioTilikaudenLopussa | number:'1.2-2'}}</td>
      </tr> -->
                      <tr>
                        <td>Tilikauden voitto (tappio)</td>
                        <!-- <td>{{data.liitetiedot.omanPaaomanMuutoksetLaskelma.tilikaudenVoittoTaiTappio | number:'1.2-2'}}</td> -->
                        <td>
                          <mat-form-field>
                            <input decimalNumberField class="skip-space-quick-toggle" type="text" [formField]="lomake.vertailulaskelma.tilikaudenVoittoTaiTappio" (input)="vertailuarvoSyotetty(data, 'tilikaudenVoittoTaiTappio')" (change)="vertailuarvoSyotetty(data, 'tilikaudenVoittoTaiTappio')" (blur)="tallennaVertailuarvot()" matInput data-lpignore="true" />
                          </mat-form-field>
                        </td>
                      </tr>
                      <!-- <tr>
      <td>Vapaa oma pääoma</td>
      <td>{{data.liitetiedot.omanPaaomanMuutoksetLaskelma.vapaaOmaPaaoma | number:'1.2-2'}}</td>
      <td>{{data.liitetiedot.omanPaaomanMuutoksetVertailulaskelma.vapaaOmaPaaoma | number:'1.2-2'}}</td>
    </tr>
    <tr>
      <td>Oma pääoma yhteensä</td>
      <td>{{data.liitetiedot.omanPaaomanMuutoksetLaskelma.omaPaaomaYhteensa | number:'1.2-2'}}</td>
      <td>{{data.liitetiedot.omanPaaomanMuutoksetVertailulaskelma.omaPaaomaYhteensa | number:'1.2-2'}}</td>
    </tr> -->
                      <tr>
                        <td>Oma pääoma + pääomalainat</td>
                        <!-- <td>{{data.liitetiedot.omanPaaomanMuutoksetLaskelma.omaPaaomaPlusPaaomalainat | number:'1.2-2'}}</td> -->
                        <td>
                          <mat-form-field>
                            <input decimalNumberField class="skip-space-quick-toggle" type="text" [formField]="lomake.vertailulaskelma.omaPaaomaPlusPaaomalainat" (input)="vertailuarvoSyotetty(data, 'omaPaaomaPlusPaaomalainat')" (change)="vertailuarvoSyotetty(data, 'omaPaaomaPlusPaaomalainat')" (blur)="tallennaVertailuarvot()" matInput data-lpignore="true" />
                          </mat-form-field>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              }
              <div style="margin: 0px 15px; font-weight: bold; margin-top: 20px">{{ 'tilikauden-aikana-tapahtuneet.title' | translatetilinpaatos: 2021 | async }}</div>
              <div style="padding: 15px 30px 20px 30px">
                <div app-kirjanpito-liitetiedot-checkbox [formDisabled]="data.lukittu" (tallennaArvo)="tallennaMuuttunutArvo($event)" type="number" [parent]="osiot.TILIKAUDEN_AIKANA_TAPAHTUNEET" [field]="kentat.OSAKEANTI" [unsaved]="data.tallentamattomat" [liitetiedot]="data.liitetiedot" (checkboxChanged)="checkboxChanged()"></div>
                <div app-kirjanpito-liitetiedot-checkbox [formDisabled]="data.lukittu" (tallennaArvo)="tallennaMuuttunutArvo($event)" type="number" [parent]="osiot.TILIKAUDEN_AIKANA_TAPAHTUNEET" [field]="kentat.SVOP_LISAYKSET" [unsaved]="data.tallentamattomat" [liitetiedot]="data.liitetiedot" (checkboxChanged)="checkboxChanged()"></div>
                <div app-kirjanpito-liitetiedot-checkbox [formDisabled]="data.lukittu" (tallennaArvo)="tallennaMuuttunutArvo($event)" type="number" [parent]="osiot.TILIKAUDEN_AIKANA_TAPAHTUNEET" [field]="kentat.SVOP_VAHENNYKSET" [unsaved]="data.tallentamattomat" [liitetiedot]="data.liitetiedot" (checkboxChanged)="checkboxChanged()"></div>
                <div app-kirjanpito-liitetiedot-checkbox [formDisabled]="data.lukittu" (tallennaArvo)="tallennaMuuttunutArvo($event)" type="number" [parent]="osiot.TILIKAUDEN_AIKANA_TAPAHTUNEET" [field]="kentat.OSINKOJEN_MAARA" [unsaved]="data.tallentamattomat" [liitetiedot]="data.liitetiedot" (checkboxChanged)="checkboxChanged()" example="Jaettujen osinkojen bruttomäärä"></div>
                <div
                  app-kirjanpito-liitetiedot-multi-input-checkbox
                  [formDisabled]="data.lukittu"
                  (tallennaArvo)="tallennaMuuttunutArvo($event)"
                  [parent]="osiot.TILIKAUDEN_AIKANA_TAPAHTUNEET"
                  [checkboxField]="kentat.YHTION_OSAKKEIDEN_LUNASTUKSET_TAI_LUOVUTUKSET"
                  [fields]="[
                    { field: kentat.YHTIO_ON_OSTANUT_OSAKKEITAAN, type: 'number', example: 'Lunastetuista osakkeista maksettu määrä' },
                    { field: kentat.YHTIO_ON_MYYNYT_OSAKKEITAAN, type: 'number', example: 'Luovutetuista osakkeista maksettu määrä' },
                  ]"
                  [unsaved]="data.tallentamattomat"
                  [liitetiedot]="data.liitetiedot"
                  (checkboxChanged)="checkboxChanged()"
                  example="Oikaisujen yhteismäärä"
                ></div>
                <div app-kirjanpito-liitetiedot-checkbox [formDisabled]="data.lukittu" (tallennaArvo)="tallennaMuuttunutArvo($event)" type="number" [parent]="osiot.TILIKAUDEN_AIKANA_TAPAHTUNEET" [field]="kentat.EDELLISEN_TILIKAUDEN_OIKAISUT" [unsaved]="data.tallentamattomat" [liitetiedot]="data.liitetiedot" (checkboxChanged)="checkboxChanged()" example="Oikaisujen yhteismäärä"></div>
                <!-- <div app-kirjanpito-liitetiedot-checkbox [formDisabled]="data.lukittu" (tallennaArvo)="tallennaMuuttunutArvo($event)" type="number" [parent]="osiot.TILIKAUDEN_AIKANA_TAPAHTUNEET" [field]="kentat.YHTIO_ON_MYYNYT_OSAKKEITAAN" [unsaved]="data.tallentamattomat" [liitetiedot]="data.liitetiedot" (checkboxChanged)="checkboxChanged()"></div>
  <div app-kirjanpito-liitetiedot-checkbox [formDisabled]="data.lukittu" (tallennaArvo)="tallennaMuuttunutArvo($event)" type="number" [parent]="osiot.TILIKAUDEN_AIKANA_TAPAHTUNEET" [field]="kentat.YHTIO_ON_OSTANUT_OSAKKEITAAN" [unsaved]="data.tallentamattomat" [liitetiedot]="data.liitetiedot" (checkboxChanged)="checkboxChanged()"></div> -->
                <div app-kirjanpito-liitetiedot-checkbox [formDisabled]="data.lukittu" (tallennaArvo)="tallennaMuuttunutArvo($event)" type="number" [parent]="osiot.TILIKAUDEN_AIKANA_TAPAHTUNEET" [field]="kentat.YHTIOLLA_PAAOMALAINAA" [unsaved]="data.tallentamattomat" [liitetiedot]="data.liitetiedot" (checkboxChanged)="checkboxChanged()" example="Pääomalaina yhteensä"></div>
              </div>
            }
          </div>
        </div>
        @if (data.liitetiedot.vertailutiedot) {
          <div style="padding: 0 15px">
            <table class="laskelmat-table" [class.one-column]="data.liitetiedot.vertailutiedot === 'ensimmainen-tilikausi'">
              <thead>
                <tr>
                  <th style="width: unset"></th>
                  <th style="width: 100px">{{ data.liitetiedot.omanPaaomanMuutoksetLaskelma.header }}</th>
                  <th style="width: 100px">{{ data.liitetiedot.omanPaaomanMuutoksetVertailulaskelma.header }}</th>
                </tr>
              </thead>
              <tbody>
                @if (data.liitetiedot.omanPaaomanMuutoksetLaskelma.osakepaaomaTilikaudenAlussaNakyvissa) {
                  <tr>
                    <td>{{ 'osakepaaoma-tilikauden-alussa' | translatetilinpaatos: 2021 | async }}</td>
                    <td>{{ data.liitetiedot.omanPaaomanMuutoksetLaskelma.osakepaaomaTilikaudenAlussa || 0 | number: '1.2-2' }}</td>
                    <td>{{ data.liitetiedot.omanPaaomanMuutoksetVertailulaskelma.osakepaaomaTilikaudenAlussa || 0 | number: '1.2-2' }}</td>
                  </tr>
                }
                @if (data.liitetiedot.omanPaaomanMuutoksetLaskelma.osakeantiNakyvissa) {
                  <tr>
                    <td>Osakeanti</td>
                    <td>{{ data.liitetiedot.omanPaaomanMuutoksetLaskelma.osakeanti || 0 | number: '1.2-2' }}</td>
                    <td>{{ data.liitetiedot.omanPaaomanMuutoksetVertailulaskelma.osakeanti || 0 | number: '1.2-2' }}</td>
                  </tr>
                }
                @if (data.liitetiedot.omanPaaomanMuutoksetLaskelma.osakepaaomaTilikaudenLopussaNakyvissa) {
                  <tr>
                    <td>Osakepääoma tilikauden lopussa</td>
                    <td>{{ data.liitetiedot.omanPaaomanMuutoksetLaskelma.osakepaaomaTilikaudenLopussa || 0 | number: '1.2-2' }}</td>
                    <td>{{ data.liitetiedot.omanPaaomanMuutoksetVertailulaskelma.osakepaaomaTilikaudenLopussa || 0 | number: '1.2-2' }}</td>
                  </tr>
                }
                @if (data.liitetiedot.omanPaaomanMuutoksetLaskelma.muutPaaomanEhtoisiinEratNakyvissa) {
                  <tr>
                    <td>Muut pääoman ehtoiset erät</td>
                    <td>{{ data.liitetiedot.omanPaaomanMuutoksetLaskelma.muutPaaomanEhtoisiinErat || 0 | number: '1.2-2' }}</td>
                    <td>{{ data.liitetiedot.omanPaaomanMuutoksetVertailulaskelma.muutPaaomanEhtoisiinErat || 0 | number: '1.2-2' }}</td>
                  </tr>
                }
                @if (data.liitetiedot.omanPaaomanMuutoksetLaskelma.sidottuOmaPaaomaNakyvissa) {
                  <tr>
                    <td>&nbsp;</td>
                    <td></td>
                    <td></td>
                  </tr>
                }
                @if (data.liitetiedot.omanPaaomanMuutoksetLaskelma.sidottuOmaPaaomaNakyvissa) {
                  <tr>
                    <td>Sidottu oma pääoma</td>
                    <td>{{ data.liitetiedot.omanPaaomanMuutoksetLaskelma.sidottuOmaPaaoma || 0 | number: '1.2-2' }}</td>
                    <td>{{ data.liitetiedot.omanPaaomanMuutoksetVertailulaskelma.sidottuOmaPaaoma || 0 | number: '1.2-2' }}</td>
                  </tr>
                }
                @if (data.liitetiedot.omanPaaomanMuutoksetLaskelma.svopTilikaudenAlussaNakyvissa || data.liitetiedot.omanPaaomanMuutoksetLaskelma.svopLisayksetTilikaudenAikanaNakyvissa || data.liitetiedot.omanPaaomanMuutoksetLaskelma.svopVahennyksetTilikaudenAikanaNakyvissa) {
                  <tr>
                    <td>&nbsp;</td>
                    <td></td>
                    <td></td>
                  </tr>
                }
                @if (data.liitetiedot.omanPaaomanMuutoksetLaskelma.svopTilikaudenAlussaNakyvissa) {
                  <tr>
                    <td>Sijoitetun vapaan oman pääoman rahasto tilikauden alussa</td>
                    <td>{{ data.liitetiedot.omanPaaomanMuutoksetLaskelma.svopTilikaudenAlussa || 0 | number: '1.2-2' }}</td>
                    <td>{{ data.liitetiedot.omanPaaomanMuutoksetVertailulaskelma.svopTilikaudenAlussa || 0 | number: '1.2-2' }}</td>
                  </tr>
                }
                @if (data.liitetiedot.omanPaaomanMuutoksetLaskelma.svopLisayksetTilikaudenAikanaNakyvissa) {
                  <tr>
                    <td>Lisäykset tilikaudella</td>
                    <td>{{ data.liitetiedot.omanPaaomanMuutoksetLaskelma.svopLisayksetTilikaudenAikana || 0 | number: '1.2-2' }}</td>
                    <td>{{ data.liitetiedot.omanPaaomanMuutoksetVertailulaskelma.svopLisayksetTilikaudenAikana || 0 | number: '1.2-2' }}</td>
                  </tr>
                }
                @if (data.liitetiedot.omanPaaomanMuutoksetLaskelma.svopVahennyksetTilikaudenAikanaNakyvissa) {
                  <tr>
                    <td>Vähennykset tilikaudella</td>
                    <td>{{ data.liitetiedot.omanPaaomanMuutoksetLaskelma.svopVahennyksetTilikaudenAikana || 0 | number: '1.2-2' }}</td>
                    <td>{{ data.liitetiedot.omanPaaomanMuutoksetVertailulaskelma.svopVahennyksetTilikaudenAikana || 0 | number: '1.2-2' }}</td>
                  </tr>
                }
                @if (data.liitetiedot.omanPaaomanMuutoksetLaskelma.svopTilikaudenLopussaNakyvissa) {
                  <tr>
                    <td>Sijoitetun vapaan oman pääoman rahasto tilikauden lopussa</td>
                    <td>{{ data.liitetiedot.omanPaaomanMuutoksetLaskelma.svopTilikaudenLopussa || 0 | number: '1.2-2' }}</td>
                    <td>{{ data.liitetiedot.omanPaaomanMuutoksetVertailulaskelma.svopTilikaudenLopussa || 0 | number: '1.2-2' }}</td>
                  </tr>
                }
                @if (
                  data.liitetiedot.omanPaaomanMuutoksetLaskelma.edellistenTilikausienVoittoTaiTappioTilikaudenAlussaNakyvissa ||
                  data.liitetiedot.omanPaaomanMuutoksetLaskelma.osingonjakoTilikaudellaNakyvissa ||
                  data.liitetiedot.omanPaaomanMuutoksetLaskelma.edellistenTilikausienVirheidenOikaisutNakyvissa ||
                  data.liitetiedot.omanPaaomanMuutoksetLaskelma.tilikaudellaOstetutOmatOsakkeetNakyvissa ||
                  data.liitetiedot.omanPaaomanMuutoksetLaskelma.tilikaudellaMyydytOmatOsakkeetNakyvissa
                ) {
                  <tr>
                    <td>&nbsp;</td>
                    <td></td>
                    <td></td>
                  </tr>
                }
                @if (data.liitetiedot.omanPaaomanMuutoksetLaskelma.edellistenTilikausienVoittoTaiTappioTilikaudenAlussaNakyvissa) {
                  <tr>
                    <td>Edellisten tilikausien voitto (tappio) tilikauden alussa</td>
                    <td>{{ data.liitetiedot.omanPaaomanMuutoksetLaskelma.edellistenTilikausienVoittoTaiTappioTilikaudenAlussa || 0 | number: '1.2-2' }}</td>
                    <td>{{ data.liitetiedot.omanPaaomanMuutoksetVertailulaskelma.edellistenTilikausienVoittoTaiTappioTilikaudenAlussa || 0 | number: '1.2-2' }}</td>
                  </tr>
                }
                @if (data.liitetiedot.omanPaaomanMuutoksetLaskelma.osingonjakoTilikaudellaNakyvissa) {
                  <tr>
                    <td>Osingonjako tilikaudella</td>
                    <td>{{ 0 - (data.liitetiedot.omanPaaomanMuutoksetLaskelma.osingonjakoTilikaudella || 0) | number: '1.2-2' }}</td>
                    <td>{{ 0 - (data.liitetiedot.omanPaaomanMuutoksetVertailulaskelma.osingonjakoTilikaudella || 0) | number: '1.2-2' }}</td>
                  </tr>
                }
                @if (data.liitetiedot.omanPaaomanMuutoksetLaskelma.edellistenTilikausienVirheidenOikaisutNakyvissa) {
                  <tr>
                    <td>Edellisten tilikausien virheiden oikaisut</td>
                    <td>{{ data.liitetiedot.omanPaaomanMuutoksetLaskelma.edellistenTilikausienVirheidenOikaisut || 0 | number: '1.2-2' }}</td>
                    <td>{{ data.liitetiedot.omanPaaomanMuutoksetVertailulaskelma.edellistenTilikausienVirheidenOikaisut || 0 | number: '1.2-2' }}</td>
                  </tr>
                }
                @if (data.liitetiedot.omanPaaomanMuutoksetLaskelma.tilikaudellaOstetutOmatOsakkeetNakyvissa) {
                  <tr>
                    <td>Omien osakkeiden lunastukset</td>
                    <td>{{ 0 - (data.liitetiedot.omanPaaomanMuutoksetLaskelma.tilikaudellaOstetutOmatOsakkeet || 0) | number: '1.2-2' }}</td>
                    <td>{{ 0 - (data.liitetiedot.omanPaaomanMuutoksetVertailulaskelma.tilikaudellaOstetutOmatOsakkeet || 0) | number: '1.2-2' }}</td>
                  </tr>
                }
                @if (data.liitetiedot.omanPaaomanMuutoksetLaskelma.tilikaudellaMyydytOmatOsakkeetNakyvissa) {
                  <tr>
                    <td>Omien osakkeiden luovutukset</td>
                    <td>{{ data.liitetiedot.omanPaaomanMuutoksetLaskelma.tilikaudellaMyydytOmatOsakkeet || 0 | number: '1.2-2' }}</td>
                    <td>{{ data.liitetiedot.omanPaaomanMuutoksetVertailulaskelma.tilikaudellaMyydytOmatOsakkeet || 0 | number: '1.2-2' }}</td>
                  </tr>
                }
                @if (data.liitetiedot.omanPaaomanMuutoksetLaskelma.edellistenTilikausienVoittoTaiTappioTilikaudenLopussaNakyvissa) {
                  <tr>
                    <td>Edellisten tilikausien voitto (tappio) tilikauden lopussa</td>
                    <td>{{ data.liitetiedot.omanPaaomanMuutoksetLaskelma.edellistenTilikausienVoittoTaiTappioTilikaudenLopussa || 0 | number: '1.2-2' }}</td>
                    <td>{{ data.liitetiedot.omanPaaomanMuutoksetVertailulaskelma.edellistenTilikausienVoittoTaiTappioTilikaudenLopussa || 0 | number: '1.2-2' }}</td>
                  </tr>
                }
                @if (data.liitetiedot.omanPaaomanMuutoksetLaskelma.tilikaudenVoittoTaiTappioNakyvissa) {
                  <tr>
                    <td>&nbsp;</td>
                    <td></td>
                    <td></td>
                  </tr>
                }
                @if (data.liitetiedot.omanPaaomanMuutoksetLaskelma.tilikaudenVoittoTaiTappioNakyvissa) {
                  <tr>
                    <td>Tilikauden voitto (tappio)</td>
                    <td>{{ data.liitetiedot.omanPaaomanMuutoksetLaskelma.tilikaudenVoittoTaiTappio || 0 | number: '1.2-2' }}</td>
                    <td>{{ data.liitetiedot.omanPaaomanMuutoksetVertailulaskelma.tilikaudenVoittoTaiTappio || 0 | number: '1.2-2' }}</td>
                  </tr>
                }
                @if (data.liitetiedot.omanPaaomanMuutoksetLaskelma.vapaaOmaPaaomaNakyvissa) {
                  <tr>
                    <td>&nbsp;</td>
                    <td></td>
                    <td></td>
                  </tr>
                }
                @if (data.liitetiedot.omanPaaomanMuutoksetLaskelma.vapaaOmaPaaomaNakyvissa) {
                  <tr>
                    <td>Vapaa oma pääoma</td>
                    <td>{{ data.liitetiedot.omanPaaomanMuutoksetLaskelma.vapaaOmaPaaoma || 0 | number: '1.2-2' }}</td>
                    <td>{{ data.liitetiedot.omanPaaomanMuutoksetVertailulaskelma.vapaaOmaPaaoma || 0 | number: '1.2-2' }}</td>
                  </tr>
                }
                @if (data.liitetiedot.omanPaaomanMuutoksetLaskelma.omaPaaomaYhteensaNakyvissa) {
                  <tr>
                    <td>&nbsp;</td>
                    <td></td>
                    <td></td>
                  </tr>
                }
                @if (data.liitetiedot.omanPaaomanMuutoksetLaskelma.omaPaaomaYhteensaNakyvissa) {
                  <tr>
                    <td>Oma pääoma yhteensä</td>
                    <td>{{ data.liitetiedot.omanPaaomanMuutoksetLaskelma.omaPaaomaYhteensa || 0 | number: '1.2-2' }}</td>
                    <td>{{ data.liitetiedot.omanPaaomanMuutoksetVertailulaskelma.omaPaaomaYhteensa || 0 | number: '1.2-2' }}</td>
                  </tr>
                }
                @if (data.liitetiedot.valitut[kentat.YHTIOLLA_PAAOMALAINAA] || data.onMuutPaaomanEhtoisiaEria) {
                  <tr>
                    <td>&nbsp;</td>
                    <td></td>
                    <td></td>
                  </tr>
                }
                @if (data.liitetiedot.valitut[kentat.YHTIOLLA_PAAOMALAINAA] || data.onMuutPaaomanEhtoisiaEria) {
                  <tr>
                    <td>Oma pääoma + pääomalainat</td>
                    <td>{{ data.liitetiedot.omanPaaomanMuutoksetLaskelma.omaPaaomaPlusPaaomalainat || 0 | number: '1.2-2' }}</td>
                    <td>{{ data.liitetiedot.omanPaaomanMuutoksetVertailulaskelma.omaPaaomaPlusPaaomalainat || 0 | number: '1.2-2' }}</td>
                  </tr>
                }
              </tbody>
            </table>
            @if (data.liitetiedot.omanPaaomanMuutoksetLaskelma.omaPaaomaEiTasmaa) {
              <div class="error-text" style="padding: 15px; font-size: 120%; text-align: end">Oma pääoma ei täsmää taseen kanssa!</div>
            } @else {
              <div style="color: #75d377; padding: 15px; font-size: 120%; line-height: 120%; text-align: end"><i class="fa fa-check" aria-hidden="true"></i> Oma pääoma täsmää</div>
            }
            @if (data.liitetiedot.valitut[kentat.YHTIOLLA_PAAOMALAINAA] || data.onMuutPaaomanEhtoisiaEria) {
              <div [class.mat-form-field-invalid]="lomake.paaomalainojenEhdot().touched() && onkoVirhe(lomake.paaomalainojenEhdot, 'required')" style="margin: 15px 0; font-size: 120%; font-weight: bold">Pääomalainojen pääasialliset lainaehdot ja lainoille kertynyt kuluksi kirjaamaton korko *</div>
              <div style="padding: 0 15px">
                <textarea matInput style="width: 100%; border: 1px dashed gray; padding: 3px" [formField]="lomake.paaomalainojenEhdot" (input)="tekstiMuuttui($any($event.target).value, kentat.YHTIOLLA_PAAOMALAINAA)" (blur)="tallennaTeksti(kentat.YHTIOLLA_PAAOMALAINAA)" cdkTextareaAutosize></textarea>
                @if (lomake.paaomalainojenEhdot().touched() && onkoVirhe(lomake.paaomalainojenEhdot, 'required')) {
                  <mat-error>Tarkemmat tiedot yhtiön pääomalainasta puuttuu.</mat-error>
                }
                <mat-hint style="padding: 8px">
                  Esim.<br />
                  <br />
                  1 Laina on tarkoitettu pääomarakenteen vahvistamiseksi.<br />
                  <br />
                  2 Pääoma ja korko saadaan maksaa yhtiön selvitystilassa ja konkurssissa vain kaikkia muita velkoja huonommalla etuoikeudella<br />
                  <br />
                  3 Pääoma saadaan muutoin palauttaa ja korkoa maksaa vain siltä osin, kuin yhtiön vapaan oman pääoman ja kaikkien pääomalainojen määrä maksuhetkellä ylittää yhtiön viimeksi päättyneeltä tilikaudelta vahvistettavan tai sitä uudempaan tilinpäätökseen sisältyvän taseen mukaisen tappion määrän.<br />
                  <br />
                  4 Lainalle ei ole annettu vakuutta<br />
                  <br />
                  5 Lainan vuotuinen korko on<br />
                  <br />
                  6 Jos pääomalainalle tulevaa korkoa ei voida maksaa korko siirtyy maksettavaksi ensimmäisen sellaisen tilinpäätöksen perusteella, jonka perusteella se voidaan maksaa<br />
                  <br />
                  Pääomalainan kuluksi kirjaamaton korko on tilinpäätöspäivänä 450,00€<br />
                  <br />
                </mat-hint>
              </div>
            }
            <div style="margin: 15px 0; font-size: 120%; font-weight: bold">Jakokelpoinen oma pääoma</div>
            <div style="padding-left: 3.5em; padding-top: 0.5em; padding-bottom: 2em">
              <table class="laskelmat-table" style="max-width: 600px" [class.one-column]="data.liitetiedot.vertailutiedot === 'ensimmainen-tilikausi'">
                <thead>
                  <tr>
                    <th style="width: unset"></th>
                    <th style="width: 100px">{{ data.liitetiedot.omanPaaomanMuutoksetLaskelma.header }}</th>
                    <!-- <th style="width: 100px;">{{data.liitetiedot.omanPaaomanMuutoksetVertailulaskelma.header}}</th> -->
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  @if (data.liitetiedot.omanPaaomanMuutoksetLaskelma.svopTilikaudenLopussa) {
                    <tr>
                      <td>Sijoitetun vapaan oman pääoman rahasto</td>
                      <td>{{ data.liitetiedot.omanPaaomanMuutoksetLaskelma.svopTilikaudenLopussa | number: '1.2-2' }}</td>
                      <!-- <td>{{data.liitetiedot.omanPaaomanMuutoksetVertailulaskelma.svopTilikaudenLopussa | number:'1.2-2'}}</td> -->
                      <td></td>
                    </tr>
                  }
                  @if (data.liitetiedot.omanPaaomanMuutoksetLaskelma.edellistenTilikausienVoittoTaiTappioTilikaudenLopussa) {
                    <tr>
                      <td>Edellisten tilikausien voitto (tappio)</td>
                      <td>{{ data.liitetiedot.omanPaaomanMuutoksetLaskelma.edellistenTilikausienVoittoTaiTappioTilikaudenLopussa | number: '1.2-2' }}</td>
                      <!-- <td>{{data.liitetiedot.omanPaaomanMuutoksetVertailulaskelma.edellistenTilikausienVoittoTaiTappioTilikaudenLopussa | number:'1.2-2'}}</td> -->
                      <td></td>
                    </tr>
                  }
                  @if (data.liitetiedot.omanPaaomanMuutoksetLaskelma.tilikaudenVoittoTaiTappio) {
                    <tr>
                      <td>Tilikauden voitto (tappio)</td>
                      <td>{{ data.liitetiedot.omanPaaomanMuutoksetLaskelma.tilikaudenVoittoTaiTappio | number: '1.2-2' }}</td>
                      <!-- <td>{{data.liitetiedot.omanPaaomanMuutoksetVertailulaskelma.tilikaudenVoittoTaiTappio | number:'1.2-2'}}</td> -->
                      <td></td>
                    </tr>
                  }
                  @for (rivi of data.liitetiedot.jakokelpoinenOmaPaaomaRivit; track trackByTunnus($index, rivi)) {
                    @if (!rivi.poistettu) {
                      <tr>
                        <td>
                          <mat-form-field style="max-width: 400px">
                            <input type="text" class="skip-space-quick-toggle" [formField]="jakokelpoisenRivienKuvaukset.kentta(rivi.tunnus)" (blur)="tallennaJakokelpoinenOmaPaaoma()" (input)="jakokelpoinenOmaPaaomaRivinTekstiMuuttui($any($event.target).value, rivi)" matInput data-lpignore="true" />
                          </mat-form-field>
                        </td>
                        <td>
                          @let maara = jakokelpoisenRivienMaarat.kentta(rivi.tunnus);
                          <mat-form-field>
                            <input matInput decimalNumberField class="skip-space-quick-toggle" type="text" [formField]="maara" (blur)="tallennaJakokelpoinenOmaPaaoma()" (input)="jakokelpoinenOmaPaaomaRivinSummaMuuttui(maara().value(), rivi)" (change)="jakokelpoinenOmaPaaomaRivinSummaMuuttui(maara().value(), rivi)" matInput data-lpignore="true" />
                          </mat-form-field>
                        </td>
                        <td>
                          <app-icon-button (click)="deleteRivi(rivi)" actionId="Poista rivi (liitetiedot)" additionalClass="remove-btn"><i class="icon ion-ios-trash icon-btn"></i></app-icon-button>
                        </td>
                      </tr>
                    }
                  }
                  <tr>
                    <td>Yhteensä</td>
                    <td>{{ data.liitetiedot.omanPaaomanMuutoksetLaskelma.jakokelpoinenOmaPaaomaYhteensa | number: '1.2-2' }}</td>
                    <!-- <td>{{data.liitetiedot.omanPaaomanMuutoksetVertailulaskelma.jakokelpoinenOmaPaaomaYhteensa | number:'1.2-2'}}</td> -->
                    <td></td>
                  </tr>
                </tbody>
              </table>
            </div>
            @if (!data.lukittu) {
              <app-button (click)="lisaaJakokelpoinenOmaPaaomaRivi()" actionId="Avattu muokkausnäkymä: Lisää jakokelpoinen oma pääoma rivi (liitetiedot)"> + Lisää rivi </app-button>
            }
          </div>
        }
        <div style="margin-bottom: 20px">
          <label [class.mat-form-field-invalid]="lomake.osingonjako().touched() && onkoVirhe(lomake.osingonjako, 'required')" style="margin: 15px 0; font-size: 120%; font-weight: bold; display: block" id="osingonjako-radio-group-label">Hallituksen ehdotus jakokelpoisen vapaan oman pääoma käytöstä</label>
          <div style="background-color: #f2f2f2; padding: 10px 10px 0px 10px">
            @if (jakokelpoinenOmaPaaomaEiRiitaObservable | async) {
              <div class="error-text" style="text-align: center; padding: 20px; font-weight: bold">Jakokelpoinen oma pääoma ei riitä!</div>
            }
            <mat-radio-group aria-labelledby="osingonjako-radio-group-label" [formField]="lomake.osingonjako">
              <mat-radio-button [value]="'ei-jaeta'">Osinkoa ei jaeta</mat-radio-button><br />
              <mat-radio-button [value]="'esilaskettu-prosentti'">Osinkoa jaetaan 8% omasta pääomasta ({{ data.liitetiedot.osingonjakoEsilaskettuOsinkoPerOsake | number: '1.2-10' }} euroa per osake eli yhteensä {{ data.liitetiedot.osingonjakoEsilaskettuMaara | number: '1.2-2' }} euroa.)</mat-radio-button><br />
              @if (data.liitetiedot.osingonjako === 'esilaskettu-prosentti') {
                <div class="gray-text" style="padding-bottom: 10px; padding-top: 5px; padding-left: 35px; font-size: 120%">Huom! Summa on laskettu suoraan liitetietojen omasta pääomasta, eikä siinä olla otettu huomioon esim. osakasvelkoja tai kustannustukia tai muita seikkoja, jotka vaikuttavat jaettavien osinkojen määrään.</div>
              }
              <mat-radio-button [value]="'annettu-maara'"
                >Osinkoa jaetaan
                <mat-form-field style="margin-left: 5px; width: 100px">
                  <input #osingonMaaraInput decimalNumberField class="skip-space-quick-toggle" type="text" [formField]="lomake.osingonMaara" (blur)="automaattitallennaOsingonMaara()" (input)="osingonMaaraMuuttui(lomake.osingonMaara().value())" (change)="osingonMaaraMuuttui(lomake.osingonMaara().value())" (appOnDisabled)="osingonMaaraInputDisabledChanged($event)" matInput data-lpignore="true" />
                </mat-form-field>
                euroa
              </mat-radio-button>
            </mat-radio-group>
            @if (lomake.osingonjako().touched() && onkoVirhe(lomake.osingonjako, 'required')) {
              <mat-error>Tieto osingojaosta puuttuu.</mat-error>
            }
            @if (data.liitetiedot.osingonjakoEsilaskettuOsakkeidenLukumaara < 1) {
              <mat-error>Tuntemistiedoissa ei ole osakkaita tai osakkeiden lukumäärä on nolla. Tarkista tuntemistiedot.</mat-error>
            }
          </div>
          @if (data.liitetiedot.osingonjako === 'esilaskettu-prosentti' || data.liitetiedot.osingonjako === 'annettu-maara') {
            <!-- {{ osinkoinputModel?.errors | json }} -->
            <div style="background-color: #f2f2f2; padding: 10px 10px 0px 10px; margin-top: 20px">
              <!-- aria-labelledby="osingonjako-radio-group-label" -->
              <mat-radio-group [formField]="lomake.osingotNostettavissa">
                <mat-radio-button [value]="'yhtiokokouksen-jalkeen'">Osinko on nostettavissa heti yhtiökokouksen jälkeen</mat-radio-button><br />
                <mat-radio-button [value]="'pvm'"
                  >Osinko on nostettavissa
                  <mat-form-field style="margin-left: 5px; width: 120px">
                    <mat-label>Päivämäärä</mat-label>
                    <input
                      #osinkoNostettavissaInput
                      class="skip-space-quick-toggle"
                      type="text"
                      [matDatepicker]="osinkoNostettavissaPicker"
                      [formField]="lomake.osingotNostettavissaPvm"
                      (input)="osingonNostettavissaPvmMuuttui(lomake.osingotNostettavissaPvm().value(), osinkoNostettavissaInput.value)"
                      (dateChange)="osingonNostettavissaPvmMuuttui(lomake.osingotNostettavissaPvm().value(), osinkoNostettavissaInput.value)"
                      (blur)="automaattitallennaOsingonjaonNostettavissaPaivamaara()"
                      (appOnDisabled)="osingotNostettavissaInputDisabledChanged($event)"
                      matInput
                      data-lpignore="true"
                    />
                    <mat-datepicker-toggle matSuffix [for]="osinkoNostettavissaPicker"></mat-datepicker-toggle>
                    @if (lomake.osingotNostettavissaPvm().touched() && onkoVirhe(lomake.osingotNostettavissaPvm, 'required')) {
                      <mat-error>Päivämäärä puuttuu.</mat-error>
                    }
                    @if (lomake.osingotNostettavissaPvm().touched() && onkoVirhe(lomake.osingotNostettavissaPvm, 'matDatepickerParse')) {
                      <mat-error>Päivämäärä on virheellinen.</mat-error>
                    }
                  </mat-form-field>
                  <mat-datepicker #osinkoNostettavissaPicker (closed)="automaattitallennaOsingonjaonNostettavissaPaivamaara()"></mat-datepicker>
                </mat-radio-button>
              </mat-radio-group>
              @if (lomake.osingotNostettavissa().touched() && onkoVirhe(lomake.osingotNostettavissa, 'required')) {
                <mat-error>Tieto milloin osinko on nostettavissa puuttuu.</mat-error>
              }
            </div>
            @if (osingotSaatetaanMaksaaSamanaVuonnaObservable | async) {
              <mat-error>Huomaathan, että osinkoa ollaan maksamassa samana vuonna kuin tilikausi päättyy ja tämä voi vaikuttaa osinkojen verotukseen.</mat-error>
            }
          }
        </div>
        @if (data.liitetiedot.osingonjako === 'ei-jaeta') {
          <div style="padding-bottom: 15px">
            @if (data.liitetiedot.omanPaaomanMuutoksetLaskelma.tilikaudenVoittoTaiTappio >= 0) {
              <!-- Todettiin, että vahvistettu tulos osoittaa {{data.liitetiedot.omanPaaomanMuutoksetLaskelma.tilikaudenVoittoTaiTappio | number:'1.2-2'}} euron voittoa. Päätettiin, että osinkoa ei jaeta. Päätettiin kirjata voitto edellisten tilikausien voitto / tappio -tilille. -->
              Hallitus ehdottaa, että osinkoa ei jaeta ja tilikauden voitto kirjataan edellisten tilikausien voitto/tappio -tilille.
            }
            @if (data.liitetiedot.omanPaaomanMuutoksetLaskelma.tilikaudenVoittoTaiTappio < 0) {
              <!-- Todettiin, että vahvistettu tulos osoittaa {{Math.abs(data.liitetiedot.omanPaaomanMuutoksetLaskelma.tilikaudenVoittoTaiTappio) | number:'1.2-2'}} euron tappiota. Päätettiin kirjata tappio edellisten tilikausien voitto / tappio -tilille. -->
              Hallitus ehdottaa, että osinkoa ei jaeta ja tilikauden tappio kirjataan edellisten tilikausien voitto/tappio -tilille.
            }
          </div>
        }
        @if (data.liitetiedot.osingonjako === 'annettu-maara' || data.liitetiedot.osingonjako === 'esilaskettu-prosentti') {
          <div style="padding-bottom: 15px">
            @if (data.liitetiedot.omanPaaomanMuutoksetLaskelma.tilikaudenVoittoTaiTappio >= 0) {
              Hallitus ehdottaa, että osinkoa jaetaan {{ data.liitetiedot.osinkoPerOsake | number: '1.2-10' }} euroa per osake eli yhteensä {{ data.liitetiedot.osinkojaYhteensa | number: '1.2-2' }} euroa. Osinko on nostettavissa {{ data.liitetiedot.osingotNostettavissa === 'pvm' ? (data.liitetiedot.osingotNostettavissaPvm | lnumberpvm | async) : 'heti yhtiökokouksen jälkeen' }}. Loppuosa
              tilikauden voitosta kirjataan edellisten tilikausien voitto/tappio -tilille. <br /><br />
              Hallituksen näkemyksen mukaan ehdotettu osinko ei vaaranna yhtiön maksukykyä.
            }
            @if (data.liitetiedot.omanPaaomanMuutoksetLaskelma.tilikaudenVoittoTaiTappio < 0) {
              Hallitus ehdottaa, että osinkoa jaetaan {{ data.liitetiedot.osinkoPerOsake | number: '1.2-10' }} euroa per osake eli yhteensä {{ data.liitetiedot.osinkojaYhteensa | number: '1.2-2' }} euroa. Osinko on nostettavissa {{ data.liitetiedot.osingotNostettavissa === 'pvm' ? (data.liitetiedot.osingotNostettavissaPvm | lnumberpvm | async) : 'heti yhtiökokouksen jälkeen' }}. Tilikauden tappio
              kirjataan edellisten tilikausien voitto/tappio -tilille. <br /><br />
              Hallituksen näkemyksen mukaan ehdotettu osinko ei vaaranna yhtiön maksukykyä.
            }
          </div>
        }
        <h2 class="otsikko">
          Luettelo kirjanpidoista ja aineistoista (KPL 2:7a)
          <!-- <button mat-icon-button style="vertical-align: top;" (click)="avaaInfoTeksti('Tässä on teksti')">
  <i class="icon ion-ios-information-circle-outline" style="font-size: 28px; color: gray;" aria-hidden="true"></i>
</button> -->
        </h2>
        <div style="margin: 15px 0">Luettelo kirjanpidoista ja aineistoista on esitetty erillisessä PDF-dokumentissa. Dokumenttia säilytetään tilinpäätöksen yhteydessä Tilitoimisto Lemon Tree Oy:n tietojärjestelmässä tai kirjanpitovelvollisen hallinnoimilla sähköisillä tallennusvälineillä.</div>
        <!-- <h2 class="otsikko">Luettelo kirjanpidoista ja aineistoista</h2>
<ul>
  <li>Tilinpäätös</li>
  <li>Tase-erittelyt</li>
  <li>Tilikohtainen tuloslaskelma</li>
  <li>Tilikohtainen tase</li>
  <li>Tililuettelo</li>
  <li>Pää- ja päiväkirjat</li>
</ul>
<h2 class="otsikko">Tositteiden lajit ja säilytystavat</h2>
<ng-container *ngIf="maksutapojenTunnisteetJoissaOnKirjauksiaObservable | async as tunnisteet">
  Tositelajit
  <ul>
    <li *ngFor="let tunniste of tunnisteet">{{tunniste}}</li>
  </ul>
</ng-container>
<div>Tilikauden tositteet ja muu kirjanpitoaineisto säilytetään sähköisillä tallennusvälineillä</div> -->
        @if (!data.lukittu) {
          <app-button (click)="fileInput.click()" actionId="Valitse tiedosto: Lisää liitetietotosite"> + Lisää liitetietotosite </app-button>
        }
        @if (latausVirheObservable | async; as latausVirhe) {
          <div class="error-text" style="margin: 1.5em">{{ latausVirhe }}</div>
        }
        <table>
          @for (liite of liitteetObservable | async; track trackByAvain(i, liite); let i = $index) {
            <tr>
              <td>
                <app-icon-button (click)="deleteAttachment(liite)" actionId="Poista liitetietotosite" additionalClass="remove-btn"><i class="icon ion-ios-trash icon-btn"></i></app-icon-button>
                <app-icon-button (click)="downloadAttachment(liite)" actionId="Lataa liitetietotosite" additionalClass="download-btn"><i class="icon ion-ios-cloud-download-outline icon-btn"></i></app-icon-button>
              </td>
              <td>Liitetietotosite {{ i + 1 }}:</td>
              <td>{{ liite.nimi }}</td>
            </tr>
          }
        </table>
        @if (!data.liitetiedot.allekirjoitetaanLemonaidissa) {
          <h2 class="otsikko">
            {{ 'ALLEKIRJOITUKSET.title' | translatetilinpaatos: 2021 | async }}
            <!-- <button mat-icon-button style="vertical-align: top;" (click)="avaaInfoTeksti('Tässä on teksti')">
    <i class="icon ion-ios-information-circle-outline" style="font-size: 28px; color: gray;" aria-hidden="true"></i>
  </button> -->
          </h2>
          <!-- [info]="'Vaihto-omaisuuden käyttöjärjestys on lähtökohtaisesti FIFO (first in first out) -periaatteen mukainen. Jos siitä poiketaan, pitää antaa liitetieto.'" [example]="'Suoritetusta tilintarkastuksesta on tänään annettu kertomus.<br /><br />
          Helsingissä _______.2022<br />
          <br /><br />
          Matin tilintarkastus Oy<br />
          Tilintarkastusyhteisö<br />
          <br /><br />
          Matti Meikäläinen<br />
          KHT'" -->
          <div
            app-kirjanpito-liitetiedot-checkbox
            [formDisabled]="data.lukittu"
            (tallennaArvo)="tallennaMuuttunutArvo($event)"
            [parent]="osiot.ALLEKIRJOITUKSET"
            [field]="kentat.ALLEKIRJOITUSTEN_TEKSTI"
            [unsaved]="data.tallentamattomat"
            [liitetiedot]="data.liitetiedot"
            [checkboxDisabled]="true"
            (checkboxChanged)="checkboxChanged()"
            [example]="'Esim.
          <br /><br /><br /><br />
          _____________________________<br />
          Matti Meikäläinen<br />
          Toimitusjohtaja
          <br /><br />
          _____________________________<br />
          Päivämäärä
          <br /><br />
          _____________________________<br />
          Paikka
          <br /><br /><br /><br /><br />
          _____________________________<br />
          Meikäläisen Matti<br />
          Hallituksen puheenjohtaja
          <br /><br />
          _____________________________<br />
          Päivämäärä
          <br /><br />
          _____________________________<br />
          Paikka
          <br /><br /><br /><br /><br />
          _____________________________<br />
          Mäkeläisen Matti Vaan<br />
          Hallituksen jäsen
          <br /><br />
          _____________________________<br />
          Päivämäärä
          <br /><br />
          _____________________________<br />
          Paikka
          <br /><br /><br /><br /><br />
          '"
          ></div>
        }
        @if (data.liitetiedot.tilintarkastetaan) {
          <h2 class="otsikko">
            {{ 'TTL3.title' | translatetilinpaatos: 2021 | async }}
            <!-- <button mat-icon-button style="vertical-align: top;" (click)="avaaInfoTeksti('Tässä on teksti')">
    <i class="icon ion-ios-information-circle-outline" style="font-size: 28px; color: gray;" aria-hidden="true"></i>
  </button> -->
          </h2>
          <!-- [info]="'Vaihto-omaisuuden käyttöjärjestys on lähtökohtaisesti FIFO (first in first out) -periaatteen mukainen. Jos siitä poiketaan, pitää antaa liitetieto.'" -->
          <div
            app-kirjanpito-liitetiedot-checkbox
            [formDisabled]="data.lukittu"
            (tallennaArvo)="tallennaMuuttunutArvo($event)"
            [parent]="osiot.TTL3"
            [field]="kentat.TTL3_4"
            [unsaved]="data.tallentamattomat"
            [liitetiedot]="data.liitetiedot"
            [checkboxDisabled]="true"
            (checkboxChanged)="checkboxChanged()"
            [example]="'Esim. Suoritetusta tilintarkastuksesta on tänään annettu kertomus.<br /><br />
          Helsingissä _______.2022<br />
          <br /><br /><br /><br /><br />
          Matin tilintarkastus Oy<br />
          Tilintarkastusyhteisö<br />
          <br /><br /><br /><br /><br />
          Matti Meikäläinen<br />
          KHT'"
          ></div>
        }
      }
    </div>
    <div style="text-align: right; padding: 30px 0">
      @if (!data.lukittu) {
        <app-primary-button (click)="tallenna(data.liitetiedot)" actionId="Tallenna liitetiedot" [actionContext]="$any(lomake().value())"> Tallenna </app-primary-button>
      }
    </div>
  </form>
} @else {
  <mat-spinner style="margin-left: auto; margin-right: auto; margin-top: 20px"></mat-spinner>
}

<input #fileInput type="file" style="visibility: hidden" accept="*" multiple (change)="lataa($event)" />

<ng-template #lisarivitTemplate let-data="data" let-osio="osio">
  <div class="lisatiedot-status">
    @if (osionLisarivitSaveSuccessMap.has(osio)) {
      <span>
        <span class="save-success-text" [@quickInSlowOut]="'in'" style="color: gray"> Arvot tallennettiin </span>
        <mat-icon class="save-success-icon" [@quickInSlowOut]="'in'" [ngStyle]="{ color: '#4bd76b', 'vertical-align': 'middle' }">done</mat-icon>
      </span>
    }
  </div>

  @for (lisatieto of data.liitetiedot.osionLisarivit?.[osio]; track lisatieto; let index = $index) {
    @if (!lisatieto.poistettu) {
      <div class="lisatieto">
        <div class="lisatieto-otsikko">
          <textarea class="lisatiedot-otsikko" placeholder="Otsikko" cdkAutosizeMaxRows="1" matInput (blur)="tallennaOsionLisarivi(osio)" [formField]="osionLisarivienOtsikot.kentta(osio + '_' + lisatieto.tunnus)" (input)="osionLisariviMuuttui(osio, $any($event.target).value, lisatieto, 'otsikko')" cdkTextareaAutosize></textarea>
          <app-icon-button (click)="poistaOsionLisarivi(osio, lisatieto)" actionId="Avasi dialogin: Poista osion lisärivi (liitetiedot)" styles="vertical-align: top;">
            <i class="icon ion-ios-trash icon-btn" style="font-size: 24px; color: gray" aria-hidden="true"></i>
          </app-icon-button>
        </div>
        <textarea class="lisatiedot-teksti" placeholder="Teksti" matInput (blur)="tallennaOsionLisarivi(osio)" [formField]="osionLisarivienTekstit.kentta(osio + '_' + lisatieto.tunnus)" (input)="osionLisariviMuuttui(osio, $any($event.target).value, lisatieto, 'teksti')" cdkTextareaAutosize></textarea>
      </div>
    }
  }

  <div>
    <app-icon-button (click)="lisaaOsionLisarivi(osio)" [disabled]="data.lukittu" actionId="Avattu muokkausnäkymä: Lisää osion lisärivi (liitetiedot)">
      <i class="icon ion-ios-add-circle-outline"></i>
    </app-icon-button>
  </div>
</ng-template>
